export default {
	italian: "Italià",
	english: "Anglès",
	japanese: "Japonès",
	french: "Francès",
	german: "Alemany",
	spanish: "Espanyol",
	map_config: {
		select: "Configuració de mapa",
		none: "Sense configuració",
		save: "Desar configuració",
		load: "Carregar configuració",
		save_new: "Crear nova configuració",
		save_overwrite: "Sobreescriure existent",
		save_mode: "Mode de desat",
		name: "Nom de la configuració",
		name_optional: "Nou nom (opcional)",
		name_placeholder: "Ex: Centre històric",
		keep_name: "Es conservarà el nom: {name}",
		overwrite_warning: "Es sobreescriurà la configuració seleccionada. Aquesta acció no es pot desfer.",
		load_warning: "La configuració actual del mapa se sobreescriurà amb la seleccionada.",
		locked_center: "El punt inicial està bloquejat per la configuració de mapa seleccionada.",
		no_template: "Selecciona una plantilla per gestionar configuracions de mapa.",
		saved: "Configuració desada correctament",
		loaded: "Configuració carregada correctament",
		save_error: "No s'ha pogut desar la configuració",
		load_error: "No s'ha pogut carregar la configuració",
		loading_map: "Carregant mapa...",
		disabled_event_started: "No es pot canviar la configuració amb l'esdeveniment iniciat",
	},
	preview: {
		common_sense: {
			title: "Vista prèvia Common Sense",
			dismiss_hints: "Entesos",
			tutorial_live_sync_title: "Vista prèvia en viu",
			tutorial_live_sync_text:
				"Els canvis que facis a la plantilla s'actualitzen automàticament en aquesta vista prèvia. No cal recarregar la pàgina: edita i comprova el resultat a l'instant.",
			hint_select_round:
				"Selecciona un repte i, si vols, un booster per configurar cada ronda de la vista prèvia.",
			hint_collapse:
				"Pots amagar aquest panell amb la fletxa per veure la pantalla del jugador a pantalla completa. Torna a obrir-lo quan vulguis amb el botó flotant.",
			tutorial_step_select: "Pas 1 · Repte i booster",
			tutorial_step_collapse: "Pas 2 · Amagar controls",
			tutorial_finish: "Finalitzar",
			collapse_controls: "Amagar controls",
			expand_controls: "Mostrar controls",
			unsaved_warning: "Aquesta vista prèvia mostra canvis del esborrany que encara no s'han desat.",
		
			start_game: "Iniciar joc",
		},
	},
	general: {
		download: "Descarregar",
		budget: "Pressupost",
		download_pdf: "Descarregar PDF",
		download_image: "Descarregar imatge",
		play_video: "Reproduir vídeo",
		slides: "Diapositives",
		change: "Canviar nom",
		wrong_link: "El link no és vàlid o ha expirat, si us plau, contacta la persona que t'ha enviat el link.",
		test_speed: "Provar velocitat de connexió",
		testing_speed: "Provant Velocitat...",
		speed_test_results: "Resultats de la prova de velocitat",
		speed_test_failed: "Error al provar la velocitat",
		unable_to_complete_speed_test:
			"No s'ha pogut completar la prova de velocitat. Si us plau, torna-ho a intentar.",
		excellent_speed: "Excel·lent velocitat!",
		good_speed: "Bona velocitat!",
		slow_speed: "Velocitat lenta!",
		your_connection_is_very_fast: "La teva connexió és molt ràpida!",
		your_connection_is_decent: "La teva connexió és decent!",
		your_connection_needs_improvement: "La teva connexió necessita millorar!",
		test_audio: "Provar àudio",
		testing_audio: "Reproduint àudio...",
		stop_audio: "Aturar àudio",
		audio_test_results: "Prova d'àudio",
		audio_test_success: "Si has sentit el so, l'àudio funciona correctament.",
		audio_test_failed: "Error en provar l'àudio",
		unable_to_complete_audio_test: "No s'ha pogut reproduir l'àudio. Comprova el volum i els permisos del dispositiu.",
		join: "Unir-se",
		point_gain: "Punts guanyats",
		point_loss: "Punts perduts",
		accept_event: "Vols acceptar aquest esdeveniment?",
		reject: "Rebutjar",
		one_vs_all_questions: "Preguntes 1 vs tots",
		question: "Pregunta",
		history: "Historial",
		acceptAll: "Acceptar tots",
		delivered: "Entregat",
		pending: "Pendent",
		close: "Tancar",
		collabo_title: "Aplicacio de Collaboracio",
		copy_link: "Copiar enllaç",
		go_to_link: "Anar a l'enllaç",
		enter_team_name: "Introdueix el nom de l'equip",
		organizer_options: "Opcions del monitor",
		staff_warning: "No toquis res si no ets membre del staff",
		accept: "Acceptar",
		not_answered: "No resposta",
		name_company: "Teaming App",
		back: "Enrere",
		go: "Anar",
		select: "Seleccionar",
		next: "Següent",
		team: "Equip",
		teams: "Equips",
		round: "Ronda",
		ranking: "Ranking",
		results: "Resultats",
		total: "Total",
		remaining: "Restant",
		round_remaining: "Ronda restant",
		answer: "Respondre",
		units: "Unitats",
		shop: "Botiga",
		ingredients: "Ingredients",
		rices: "Arrossos",
		plates: "Plats",
		choosing: "Escollint",
		save: "Desar",
		saved: "Desat",
		cancel: "Cancel·lar",
		name: "Nom",
		buy: "Comprar",
		photo: "Foto",
		redo: "Tornar a fer",
		password: "Contrasenya",
		exit: "Sortir",
		canceled: "Cancel·lat",
		event: "Esdeveniment",
		day: "Dia",
		ingredient: "Ingredient",
		points: "Punts",
		position: "Posició",
		agency: "Distribuïdor",
		delete: "Eliminar",
		updated: "actualitzat",
		created: "creat",
		update: "actualitzar",
		create: "crear",
		filters: "Filtres",
		apply_filters: "Aplicar filtres",
		clear_filters: "Esborrar filtres",
		search: "Cercar",
		add: "Afegir",
		start: "Començar",
		from: "Fins",
		error: "Error",
		chat: "Missatges",
		game_master: "STAFF",
		options: "Opcions",
		reactions: "Reaccions",
		team_name: "Nom d'equip",
		option_organizer: "Opcions del monitor",
		btn_send_answer: "Enviar resposta",
		btn_continue: "Continuar",
		correct_answer: "Resposta correcta",
		incorrect_answer: "Resposta incorrecta",
		challenge_complete: "Repte completat",
		instructor: "Monitor",
		edit: "Editar",
		unsaved_changes: "Hi ha canvis sense guardar",
		en: "Anglès",
		es: "Espanyol",
		yes: "Si",
		no: "No",
		ipad_title: "Aplicació de Cerca del Tresor",
		tapas_title: "Aplicació Culinària",
		utq_title: "Aplicació de gincana",
		action_title: "Aplicació de Concurs",
		cluedo_ai_title: "Aplicació d'Investigació",
		bingo_title: "Aplicació de Bingo Musical",
		common_sense_title: "Aplicació Common Sense",
		hours: "Hores",
		minutes: "Minuts",
		new: "Nou",
		mark_all_read: "Marcar tot com a llegit",
		name_app: "APLICACIÓ DE TEAMING",
		hello: "Hola",
		reload_app: "Recarregar aplicació",
		change_monitor: "Canviar monitor",
		must: "Obligatori",
		first: "Primer",
		you: "Tu",
		try_again: "Error, torna a intentar-ho",
		incorrect_fields: "Hi ha camps incorrectes al formulari",
		save_changed: "Canvi desat",
		ranking_block: "L'administrador ha amagat el rànquing",
		ranking_hidden: "El rànquing està amagat",
		ranking_display: {
			normal: "Normal",
			cooperative: "Cooperatiu",
			both: "Ambdós",
			hidden: "Amagat",
			slides: "Diapositives"
		},
		answer_correct: "Resposta correcta",
		answer_incorrect: "Resposta incorrecta",
		pair_a: "Parella A ",
		pair_b: "Parella B ",
		order_colon: "Ordre: ",
		quiz_multi: "QÜestionari multiple",
		answer_auto: "Resposta autocorregida",
		order: "Ordre",
		click_add: "Fes clic per afegir",
		click_upload: "Fes clic per pujar",
		upload: "Pujar",
		uploading: "Pujant...",
		quiz: " qüestionari",
		pairs: "Parelles",
		min_answers: "Ha de haver un mínim de {min} respostes",
		max_answers: "El límit de respostes són {max}",
		file_large: "Arxiu massa pesat, el màxim són 50MB",
		new_item: "Nou element",
		new_contact: "Nou contacte",
		add_item: "Afegeix un element",
		add_contact: "Afegeix un contacte",
		missing_items: "No hi ha cap element afegit",
		missing_contacts: "No hi ha cap contacte afegit",
		select_item: "Selecciona un element",
		select_contact: "Selecciona un contacte",
		total_price: "Total {total_price}€",
		app_activity_plus: "+ App Activitat",
		app_activity: "App Activitat",
		url_admin: "Enllaç de Setup",
		url_gm: "Enllaç del monitor",
		preview: "Previsualització",
		actions: "Accions",
		challenges: "Reptes",
		all: "Tots",
		demo_upper: "DEMO",
		demo_mode: "Mode demo",
		start_demo_mode: "Iniciar mode demo",
		stop_demo_mode: "Aturar mode demo",
		demo_mode_title: "Iniciar mode demo",
		demo_mode_stop_title: "Aturar mode demo",
		demo_mode_info_duration: "El mode demo tindrà una durada màxima de 30 minuts.",
		demo_mode_info_alert: "Els jugadors veuran una alerta indicant que estan en mode demo.",
		demo_mode_info_reset: "Tot el contingut generat durant la demo serà esborrat.",
		demo_mode_info_stop: "La demo es podrà aturar manualment des del mateix botó.",
		demo_mode_time_left: "Temps restant de demo: {time}",
		demo_mode_confirm_start: "Iniciar demo",
		demo_mode_confirm_stop: "Aturar demo i reiniciar",
		demo_mode_started: "Mode demo iniciat",
		demo_mode_stopped: "Mode demo aturat i partida reiniciada",
		demo_mode_banner: "Estàs jugant en mode demo. El progrés s'esborrarà.",
		demo_mode_active: "El mode demo està actiu",
		invalid_url: "La URL no és vàlida",
		open: "Obrir",
		chat_with_gm: "Xat amb el monitor",
		cluedo_ai_act: "Aplicació d'Investigació",
		submit: "Enviar",
		not_started: "El joc encara no ha començat",
		no_picture: "No hi ha foto d'equip",
		upload_team_picture: "Foto d'equip",
		plates_rices: "Plats/Arrossos",
		done: "Superat",
		challenge: "Repte",
		no_data: "No hi ha dades",
		link_monitors: "Enllaç Monitors",
		preview_not_able: "No es pot previsualitzar aquest contingut",
		gateway_preview_language: "Idioma",
		gateway_preview_settings: "Settings",
		are_you_sure: "Estàs segur?",
	
		show_qr: "Mostrar codi QR",
		slides_tooltip: "Imatges que es poden mostrar a la pantalla del ranking per explicar o començar el joc.",
	},
	join_lobby: {
		title: "Uneix-te al lobby",
		subtitle: "Introdueix el teu nom i espera fins que el personal creï els equips.",
		enable: "Activar sala d'espera",
		demo_disabled: "JoinLobby no es pot activar en esdeveniments demo.",
		use_locations: "Utilitzar ubicacions",
		locations_before_link_hint:
			"Assegura't que les ubicacions estan configurades correctament abans de compartir l'enllaç del lobby amb els jugadors.",
		locations: "Ubicacions",
		locations_placeholder: "Escriu una ubicació i prem enter",
		location: "Ubicació",
		location_placeholder: "Selecciona la teva ubicació",
		name_placeholder: "Introdueix el teu nom",
		join_lobby: "Sala d'espera",
		waiting_staff: "Estàs al lobby. El personal crearà els equips aviat.",
		players_online: "Jugadors en línia",
		no_location: "Sense ubicació",
		join_random_team: "Unir-se a un equip aleatori",
		staff_title: "Configuració JoinLobby",
		lobby_link: "Enllaç del lobby",
		players_per_team: "Jugadors per equip",
		players_per_team_location: "Jugadors per equip ({location})",
		teams: "Equips",
		total_players: "Total de jugadors",
		total_players_with_count: "Total de jugadors: {count}",
		total_teams_with_count: "Total d'equips: {count}",
		teams_will_be_created: "Es crearan {count} equips",
		teams_already_created_message:
			"Els equips ja estan creats. Els jugadors ara poden unir-se a un equip aleatori amb l'URL del lobby de dalt.",
		create_teams: "Crear equips",
		teams_created: "Equips creats",
		button_tooltip: "Permet que els jugadors s'uneixin a les activitats i després formin els equips",
		enable_tooltip: "Permet que els participants entrin en una sala d'espera per crear equips aleatòriament o accedir a equips predefinits. S'utilitza principalment en activitats online o en casos concrets.",
	},
	analytics: {
		feedback_tab: "Feedback",
		budget_tab: "Pressupost",
		events_tab: "Esdeveniments",
		budget_coming_soon: "Pàgina de pressupost (aviat)",
		number_of_events: "Nombre d'esdeveniments",
		total_eur: "Total €",
		mean_eur_event: "Mitjana € Esdeveniment",
		mean_eur_teambuilding_event: "Mitjana € Esdeveniment Teambuilding",
		mean_pax_event: "Mitjana Pax Esdeveniment",
		show_plot_1: "Mostrar Gràfic 1",
		show_plot_2: "Mostrar Gràfic 2",
		month_1: "Gener",
		month_2: "Febrer",
		month_3: "Març",
		month_4: "Abril",
		month_5: "Maig",
		month_6: "Juny",
		month_7: "Juliol",
		month_8: "Agost",
		month_9: "Setembre",
		month_10: "Octubre",
		month_11: "Novembre",
		month_12: "Desembre",
		number_of_budget: "Nombre de pressupostos",
		number_of_closed_budget: "Nombre de pressupostos tancats",
		number_of_lost_budget: "Número de pressupostos perduts",
		percent_of_closed_budget: "% de pressupostos tancats",
		number_of_open_budget: "Número de pressupostos oberts",
		number_of_won_budget: "Número de pressupostos guanyats",
		all_months: "Tots els mesos",
		anual_income: "Ingressos anuals",
		type_of_activity: "Activitat",
		type_of_event_budget: "Tipus d'esdeveniment",
		euro_event: "€ Esdeveniment",
		euro_extra: "€ Extra",
		event_place: "Ubicació d'esdeveniments",
		review_summary: "Resum de Ressenyes",
		total_events: "Total d'Esdeveniments",
		events_with_reviews: "Esdeveniments amb Ressenyes",
		review_rate: "Taxa de Ressenyes",
		category_averages: "Mitjanes per Categoria",
		review_details: "Detalls de Reseñas",
		expectations: "Expectatives",
		scale: "Escala",
		game_masters: "Game Masters",
		content: "Contingut",
		service_prices: "Servei/Preus",
		organization: "Organització",
		hire_again: "Contractar de Nou",
		reviews: "reseñas",
		event_id: "ID de l'Esdeveniment",
		activity: "Activitat",
		overall_scale: "Escala General",
		stars: "estrelles"
	},
	menu: {
		analytics: "Analytics",
		sales: "Vendes",
		budgets: "Pressupostos",
		clients: "Clients",
		bookings: "Reserves",
		booking_list: "Llista de reserves",
		calendar: "Calendari",
		summaries: "Resums",
		activities: "Activitats",
		demos: "Demos",
		content: "Contingut",
		settings: "Plantilles",
		settings_erp: "Configuració",
		organization: "Organització",
		activities_erp: "Catàleg",
		event_service: "Serveis d'esdeveniment",
		extras: "Pàgina extres",
		final_page_budget: "Pàgina final pressupost",
		activities_questions: "Preguntes de la reserva",
		credits_consumption: "Consum de crèdits",
		superadmin: "Superadmin",
		superadmin_credits: "Crèdits (totes les orgs)",
		superadmin_organization_stats: "Estadístiques per org",
		favorite_photos: "Fotos favorites",
		app_personalization: "Personalització de l'app",
		integrations: "Integracions",
		add_staff: "+ Afegir monitor",
		my_activities: "Les meves activitats",
		staff: "Monitor",
		notifications: "Notificacions",
		changelog: "Novetats",
		logout: "Tancar sessió",
		switch_organization_label: "Organització activa",
		switch_organization_confirm_title: "Canviar d'organització?",
		switch_organization_confirm_message:
			'Treballaràs com a "{name}". La pàgina es recarregarà i es pot perdre el que no estigui desat.',
		switch_organization_confirm: "Canviar",
		switch_organization_error: "No s'ha pogut canviar d'organització"
	},
	superadmin: {
		credits: {
			title: "Crèdits de totes les organitzacions",
			subtitle: "Agrupa consums per mes per facturar i anul·lar partides de prova",
			filters: "Filtres",
			organization: "Organització",
			organization_filter_mode: "Mode orgs",
			organization_include: "Incloure seleccionades",
			organization_exclude: "Excloure seleccionades",
			all_organizations: "Totes les organitzacions",
			year: "Any",
			month: "Mes",
			status: "Estat",
			apply: "Aplicar",
			total_lines: "Línies",
			total_credits: "Crèdits",
			total_amount: "Import",
			monthly_summary: "Resum mensual",
			rows_count: "{count} períodes",
			empty_state: "No hi ha consums amb aquests filtres",
			empty_lines: "No hi ha línies en aquest període",
			col_organization: "Organització",
			col_period: "Període",
			col_lines: "Línies",
			col_credits: "Crèdits",
			col_amount: "Import",
			col_status: "Estat",
			col_actions: "Accions",
			col_date: "Data",
			col_event: "Partida",
			col_activity: "Activitat",
			view_lines: "Veure línies",
			ensure_batch: "Crear lot",
			ensure_batches_all: "Crear lots (tots)",
			batches_ensured_all: "Lots llestos: {count} (fallits: {failed})",
			batches_ensured_partial: "Alguns lots han fallat ({failed})",
			mark_invoiced: "Facturat",
			mark_paid: "Pagat",
			mark_voided: "Anul·lar lot",
			manual_invoice: "Factura manual",
			manual_invoice_dialog_title: "Factura manual",
			manual_invoice_dialog_intro:
				"Es marcarà com a facturat el període {org} · {period} sense enviar-lo a Holded.",
			manual_invoice_reference: "Referència de factura (opcional)",
			manual_invoice_reference_placeholder: "Ex. FAC-2026-001",
			manual_invoice_confirm: "Marcar com a facturat",
			manual_invoice_success: "Factura manual registrada ({org} · {period})",
			send_holded: "Holded",
			holded_soon: "Integració Holded properament",
			holded_create: "Crear a Holded",
			holded_approve: "Aprovar Holded",
			holded_send: "Enviar email",
			holded_send_invoice: "Enviar factura Holded",
			holded_create_and_email: "Crear + email",
			holded_approve_and_email: "Crear + aprovar + email",
			holded_already_sent: "Enviada a Holded",
			holded_create_email_dialog_title: "Crear factura i enviar email",
			holded_create_email_dialog_intro: "Es crearà la factura a Holded (esborrany) i s'enviarà per email.",
			holded_send_dialog_title: "Enviar factura amb Holded",
			holded_send_dialog_intro: "Es crearà, aprovarà i enviarà la factura d'aquest període de crèdits a Holded.",
			holded_flow_create_email: "Crear + email: genera l'esborrany a Holded i envia el correu (sense aprovar).",
			holded_flow_approve_email: "Crear + aprovar + email: genera, aprova i envia la factura completa.",
			holded_send_dialog_step_create: "Es crearà la factura a Holded amb els crèdits del període.",
			holded_send_dialog_step_approve: "La factura s'aprovarà automàticament.",
			holded_send_dialog_step_email: "S'enviarà un correu electrònic automàticament a l'organització ({org} · {period}).",
			holded_send_dialog_note: "Usa l'email de facturació configurat a l'organització. Revisa que tingui ID de Holded i billing mail.",
			holded_will_send_to: "El correu s'enviarà a: {email}",
			holded_contact_ok: "Holded contact ID configurat: {id}",
			holded_missing_billing_mail: "No es pot enviar: l'organització no té billing_mail configurat.",
			holded_missing_contact: "No es pot enviar: l'organització no té holded_contact_id configurat.",
			holded_error_approve: "Error en aprovar a Holded: {error}",
			holded_error_send: "La factura s'ha creat però l'email no s'ha pogut enviar: {error}",
			holded_send_confirm: "Enviar factura",
			holded_create_and_email_confirm: "Crear i enviar",
			holded_approve_and_email_confirm: "Crear, aprovar i enviar",
			holded_create_email_success: "Esborrany creat i enviat a {email} (Holded {id})",
			holded_send_invoice_success: "Factura aprovada i enviada a {email} (Holded {id})",
			holded_create_success: "Esborrany Holded creat ({id})",
			holded_approve_success: "Factura aprovada a Holded",
			holded_send_success: "Factura enviada per email",
			void_event: "Anul·lar partida",
			void_line: "Anul·lar línia",
			unvoid_line: "Desanul·lar",
			save_line: "Desar",
			save_line_success: "Línia actualitzada",
			lines_locked_holded: "Aquest període ja s'ha enviat a Holded. Les línies no es poden modificar ni anul·lar.",
			before_void: "abans d'anul·lar",
			void_line_confirm: "Anul·lar aquesta línia de crèdits?",
			void_line_success: "Línia anul·lada",
			unvoid_line_success: "Línia restaurada",
			no_event: "Sense partida",
			void_confirm: "Anul·lar tots els crèdits de \"{name}\"? Aquesta acció serveix per treure proves.",
			void_success: "S'han anul·lat {count} línies",
			batch_ensured: "Lot mensual llest",
			status_updated: "Estat actualitzat",
			load_failed: "No s'ha pogut carregar el resum de crèdits",
			load_lines_failed: "No s'han pogut carregar les línies",
			action_failed: "No s'ha pogut completar l'acció",
			status_pending: "Pendent",
			status_invoiced: "Facturat",
			status_paid: "Pagat",
			status_voided: "Anul·lat",
			month_1: "Gener",
			month_2: "Febrer",
			month_3: "Març",
			month_4: "Abril",
			month_5: "Maig",
			month_6: "Juny",
			month_7: "Juliol",
			month_8: "Agost",
			month_9: "Setembre",
			month_10: "Octubre",
			month_11: "Novembre",
			month_12: "Desembre",
		},
		organization_stats: {
			title: "Estadístiques per organització",
			subtitle: "Crèdits i euros venuts, i activitats fetes (sense anul·lats). Filtra per organització i període.",
			filters: "Filtres",
			hint_individual: "Detall de l'organització seleccionada. Les línies anul·lades no s'inclouen.",
			hint_compare: "Totals de totes les organitzacions filtrades. Selecciona'n una per al detall.",
			back_to_comparison: "Tornar a la comparativa",
			organization: "Organització",
			organizations: "Organitzacions",
			organization_filter_mode: "Mode org",
			organization_include: "Incloure seleccionades",
			organization_exclude: "Excloure seleccionades",
			year: "Any",
			month: "Mes",
			all_months: "Tots els mesos",
			apply: "Aplicar",
			totals: "Totals",
			select_organization: "Selecciona una organització",
			empty_state: "Sense dades de crèdits per a aquests filtres",
			diff_title: "A vs B",
			chart_monthly_credits: "Crèdits venuts per mes",
			chart_monthly_euros: "Euros venuts per mes",
			chart_monthly_activities: "Activitats fetes per mes",
			chart_activities: "Top activitats per crèdits",
			chart_intensity_activities: "Intensitat: crèdits per activitat",
			chart_compare_ranking: "Rànquing de crèdits per organització",
			chart_compare_intensity: "Intensitat: crèdits per activitat",
			chart_compare_monthly: "Tendència mensual de crèdits per organització",
			chart_compare_activity_mix: "Mix d'activitats per organització",
			table_compare: "Comparativa costat a costat",
			col_metric: "Mètrica",
			col_totals: "Totals",
			kpi_credits: "Crèdits venuts",
			kpi_credit_amount: "Euros venuts",
			kpi_events: "Activitats fetes",
			kpi_activities: "Tipus d'activitat",
			kpi_lines: "Línies de crèdit",
			kpi_credits_per_event: "Crèdits / activitat",
			kpi_avg_amount_per_event: "€ / activitat",
			metric_credits: "Crèdits venuts",
			metric_credit_amount: "Euros venuts",
			metric_events: "Activitats fetes",
			metric_activities: "Tipus d'activitat",
			metric_lines: "Línies de crèdit",
			metric_credits_per_event: "Crèdits / activitat",
			metric_avg_amount_per_event: "€ / activitat",
			visible_rows: "Files visibles",
			only_with_data: "Només organitzacions amb dades",
			series_credits: "Crèdits venuts",
			series_credit_amount: "Euros venuts",
			series_events: "Activitats fetes",
			series_credits_per_event: "Crèdits / activitat",
			insight_concentration: "Les 3 activitats principals ({activities}) concentren el {percent}% dels crèdits",
			load_failed: "No s'han pogut carregar les estadístiques",
		},
	},
	changelog: {
		title: "Novetats",
		subtitle: "Últimes actualitzacions i millores de l'aplicació",
		empty: "Encara no hi ha novetats publicades.",
		new: "Nou",
		mark_read: "Marcar com a llegit",
		mark_all_read: "Marcar tot com a llegit",
		view_all: "Veure tot",
		got_it: "Entesos",
		dismiss: "Tancar"
	},
	notifications: {
		empty: "No hi ha notificacions"
	},
	budgets: {
		currency: "Moneda",
		type: "Tipus",
		activities: "Activitats",
		budget_description: "Descripció del pressupost",
		placeholder_budget_description: "Descripció del pressupost",
		budgets: "Pressupostos",
		status: "Estat",
		search: "Cercar",
		search_name: "Cercar per nom",
		name: "Nom",
		client: "Client",
		people: "Persones",
		date: "Data de l'esdeveniment",
		open: "Obert",
		won: "Guanyat",
		lost: "Perdut",
		all: "Tots",
		new_budget: "Nou Pressupost",
		must_name: "Ha de tenir un nom",
		budget_validity: "Validesa del pressupost",
		hour: "Hora",
		show_total: "Mostrar total",
		language: "Idioma",
		spanish: "Espanyol",
		english: "Anglès",
		conditions: "Condicions",
		extras: "Extres",
		budget: "Pressupost",
		close_budget: " tancar pressupost",
		download: "Descarregar",
		select_option: "Selecciona una opció",
		select_items: "Selecciona els articles que es transferiran a la reserva",
		comments_close_budget: "Comentaris sobre el tancament del pressupost",
		convert: "Convertir",
		close: "Tancar",
		back: "Tornar",
		cancel: "Cancel·lar",
		line: "Afegir línia",
		line_type: "Línia",
		category: "Categoria",
		budget_type: "Tipus de Pressupost",
		auto_price: "Preu Automàtic",
		total: "Total",
		description: "Descripció",
		price_tag: "Etiqueta preu",
		pax: "Persones",
		price: "Preu",
		user: "Usuari",
		no_condition: "Sense condicions",
		comments: "Comentaris Interns",
		activity: "Activitat",
		location: "Ubicació",
		item: "Element",
		first: "Primer",
		close_convert: "Tancar/Convertir pressupost",
		comments_budget: "Afegir comentaris al pressupost",
		catalan: "Català",
		bulk_add_button: "Afegir múltiples activitats",
		bulk_add_title: "Afegir múltiples activitats",
		bulk_select_categories: "Selecciona les categories d'activitats",
		bulk_categories_placeholder: "Seleccionar categories...",
		bulk_or_search_activities: "O salta les categories i cerca en tot el catàleg.",
		bulk_browse_all_activities: "Cercar en totes les activitats",
		bulk_select_activities_all: "Cerca i selecciona activitats de tot el catàleg",
		bulk_no_activities_loaded: "No hi ha activitats disponibles per afegir",
		bulk_select_activities: "Selecciona les activitats que vols afegir",
		bulk_no_activities: "No hi ha activitats a les categories seleccionades",
		bulk_search_activities_placeholder: "Cercar per nom o codi...",
		bulk_no_activities_search: "Cap activitat coincideix amb la cerca",
		bulk_pax_hint: "Indica el nombre de persones per a les {count} activitats seleccionades",
		bulk_default_price_tag: "Etiqueta de preu per defecte",
		bulk_default_price_tag_placeholder: "Selecciona una etiqueta de preu...",
		bulk_default_price_tag_none: "Sense etiqueta per defecte",
		bulk_next: "Següent",
		bulk_add_confirm: "Afegir al pressupost"
	},
	bookingmedia: {
		uploadImages: "Pujar imatges",
		downloadImages: "Descarregar imatges",
		imagesUploaded: "Imatges pujades",
		imageRemoved: "Imatge eliminada",
		uploadFailed: "Error al pujar la imatge",
		uploadAllFailed: "No s'ha pogut pujar cap imatge. Comprova la connexió i torna-ho a provar.",
		uploadPartialSuccess: "S'han pujat {success} de {total} imatges. {failed} no s'han pogut pujar.",
		uploadRetrying: "Reintentant ({attempt}/{max})",
		notSavedForm: "Has de guardar la reserva abans de pujar imatges",
		imageUploaded: "Imatge Pujada",
		uploadedImage: "Imatge de la reserva",
		viewImage: "Veure imatge en gran",
		removeImage: "Eliminar imatge",
		removeFailed: "No s'ha pogut eliminar la imatge",
		noImages: "Encara no hi ha fotos",
		noImagesHint: "Puja imatges per documentar la reserva",
		photoCount: "{count} foto(s)",
		loadMorePhotos: "Carregar més ({count} restants)",
		noContent: "No hi ha imatges per descarregar"
	},
	favoritePhotos: {
		title: "Fotos favorites",
		subtitle: "Fotos guardades de les reserves, filtrables per reserva i activitat",
		addFavorite: "Afegir a favorits",
		removeFavorite: "Treure de favorits",
		selectActivity: "Assignar activitat",
		selectActivityHint:
			"Per defecte es selecciona la primera activitat de la reserva. Pots cercar i triar qualsevol activitat del catàleg.",
		searchActivity: "Cercar activitat...",
		searchBooking: "Cercar reserva...",
		noFilterResults: "Sense resultats",
		previousPhoto: "Foto anterior",
		nextPhoto: "Foto següent",
		downloadError: "No s'ha pogut descarregar la imatge",
		selectActivityPlaceholder: "Selecciona una activitat",
		noActivitySearchResults: "No s'han trobat activitats",
		noActivitiesCatalog: "No hi ha activitats al catàleg",
		noActivitiesInBooking: "Aquesta reserva no té activitats associades. La foto es guardarà sense activitat.",
		activity: "Activitat",
		noActivity: "Sense activitat",
		added: "Foto afegida a favorits",
		removed: "Foto eliminada de favorits",
		addError: "No s'ha pogut afegir a favorits",
		removeError: "No s'ha pogut treure de favorits",
		filterBooking: "Reserva",
		filterActivity: "Activitat",
		allBookings: "Totes les reserves",
		allActivities: "Totes les activitats",
		applyFilters: "Filtrar",
		empty: "Encara no hi ha fotos favorites",
		loadingMore: "Carregant més fotos…",
		allPhotosLoaded: "S'han mostrat les {count} fotos"
	},
	bookings: {
		file: "Fitxer",
		activity_sheet: "Fitxa de l'activitat",
		staff_document: "Document per a staff",
		responsible: "Resp",
		crm_id: "ID CRM",
		placeholder_crm_id: "ID CRM",
		pipedrive_deal_search_placeholder: "Cerca deal a Pipedrive…",
		pipedrive_open_deal: "Obrir a Pipedrive",
		pipedrive_loading_deal: "Carregant deal de Pipedrive…",
		pipedrive_deal_not_found: "No s'ha trobat el deal a Pipedrive",
		pipedrive_deal_load_error: "No s'ha pogut carregar el deal de Pipedrive",
		pipedrive_invalid_deal_id: "L'ID CRM no és un ID de deal vàlid de Pipedrive",
		staff_main: "Responsable de producció",
		gm_rejected: "Monitors rebutjats",
		accepted: "Estat",
		history_status_pending: "Pendent",
		history_status_saved: "Desat",
		history_author: "Autor",
		history_source_client: "Client",
		history_source_staff: "Staff",
		history_applied: "Aplicat",
		history_field_booking_item: "Ingressos",
		history_field_cost_item: "Despeses",
		history_field_game_master_record: "Monitors",
		file_archive_title: "Arxiu de documents",
		file_archive_file: "Arxiu",
		file_archive_section: "Secció",
		file_archive_status: "Estat",
		agent_suggestions: "Agent IA",
		agent_suggestions_title: "Agent IA",
		agent_suggestions_hint: "L'agent revisa les dades de la reserva i, si està connectat, el deal de Pipedrive i el seu fil de correus.",
		agent_suggestions_loading: "Analitzant la reserva...",
		agent_suggestions_refresh: "Tornar a analitzar",
		agent_priority_high: "Alta",
		agent_priority_medium: "Mitjana",
		agent_priority_low: "Baixa",
		agent_pipedrive_included: "Dades de Pipedrive incloses",
		agent_pipedrive_not_included: "Sense deal de Pipedrive (no connectat o sense CRM ID)",
		agent_pipedrive_emails_included: "{count} correus del deal analitzats",
		agent_pipedrive_emails_empty: "Sense correus vinculats al deal",
		agent_pipedrive_emails_error: "No s'han pogut llegir els correus del deal",
		agent_open_deal: "Obrir deal",
		agent_pipedrive_notes: "Notes CRM",
		agent_field_hint: "Camp",
		agent_no_pending: "No es detecten pendents clars.",
		agent_disabled: "L'agent no està activat a l'organització.",
		agent_error: "No s'han pogut obtenir els suggeriments.",
		file_archive_active: "Actiu",
		file_archive_removed: "Eliminat",
		media_files: "Multimèdia",
		owner: "Propietari",
		communication_platform: "Plataforma de comunicació",
		communication_url: "URL de comunicació",
		zoom: "Zoom",
		ms_teams: "MSTeams",
		webex: "Webex",
		google_meet: "GMeet",
		general: "General",
		event: "Esdeveniment",
		activity_information: "Informació de l'activitat",
		questions: "Preguntes",
		economics: "Economia",
		ratings: "Valoracions",
		bookings: "Reservas",
		media: "Mitjans",
		name: "Nom",
		placeholder_name: "Nom",
		alert_name: "Ha de tenir un nom",
		client: "Client",
		people: "Persones",
		pax_tooltip: "El nombre de participants es tancarà 10 dies abans de l'esdeveniment",
		date: "Data",
		search_name: "Cercar per nom",
		search: "Cercar",
		new_booking: "Nova Reserva",
		language: "Idioma",
		hour: "Hora activitat",
		client_logo: "Logo del client",
		logo_client_tooltip:
			"Puja el logo que s'utilitzarà en els materials i aplicacions compatibles de l'esdeveniment.",
		billing_data: "Dades de facturació (Nom empresa, NIF i adreça)",
		billing_data_tooltip:
			"Indica el nom fiscal, NIF i adreça necessaris per emetre la factura.",
		activities_app: "Activitats App",
		type_event: "Tipus d'esdeveniment",
		place: "Ubicació",
		url_location: "Enllaç Google Maps",
		place_information: "Informació de l'espai",
		place_information_tooltip: "Hi ha alguna cosa més que haguem de saber de l'espai?",
		location: "Ubicació",
		must_name: "Ha de tenir un nom",
		general_information: "Informació general",
		company_name: "Nom d'empresa",
		company_name_tooltip: "Persona responsable el dia de l'esdeveniment",
		event_general_timing: "Horari general de l'esdeveniment",
		timetable_plain_tooltip:
			"Afegeix l'agenda completa, incloent-hi arribades, reunions, àpats, activitat i finalització.",
		extra_information: "Informació extra",
		extra_information_internal: "Informació extra interna",
		timeline: "Horari",
		description: "Descripció",
		add_activity: "Afegir activitat",
		save_before_add_activity: "Has de desar el formulari abans d'afegir activitats.",
		number_teams: "Número d'equips",
		team_number_tooltip:
			"Nombre d'equips en què es dividiran els participants.",
		staff_people: "Núm. de monitors",
		teams: "Equips",
		staff: "Monitors",
		add_team: "Afegir equip",
		add_staff: "+ Afegir monitor",
		contact_person: "Persona de contacte",
		add_person_contact: "Afegir persona de contacte",
		add_item: "Afegeix un element",
		new_contact: "Nou contacte",
		add_questions: "Afegir preguntes",
		modify_questions: "Modificar preguntes",
		add: "Afegir",
		all_questions: "Totes les preguntes",
		activity_questions: "Preguntes de la reserva",
		costs: "Costos",
		price: "Preu",
		activity: "Activitat",
		activities: "Activitats",
		activity_ies: "Activitat/s",
		reserve_item: "Serveis",
		gm_pay: "Costos de personal",
		add_gm: "+ Afegir monitor",
		game_master: "Monitor",
		monitor_info: "Info del monitor",
		no_visible_monitor_fields: "No hi ha informació visible per a aquest monitor",
		salary: "Salari",
		total: "Total",
		gm_valoration: "Valoració del monitor",
		client_valoration: "Valoració del client",
		es: "Espanyol",
		en: "Anglès",
		cat: "Català",
		email: "Correu electrònic",
		phone: "Telèfon",
		extra: "Extra",
		online: "En línia",
		in_person: "Presencial",
		booking_activities: "Activitats App",
		name_place: "Nom del lloc",
		direction_location: "Adreça url lloc",
		add_cost: "Afegir cost",
		add_field: "Afegir camp",
		review_gm_enjoy: "Els participants s'ho han passat bé?",
		review_gm_size: "Com valores el nombre de monitors per aquesta activitat?",
		review_gm_previous_info: "Com valores la informació prèvia a l'activitat?",
		review_gm_started: "Quan ha començat l'activitat?",
		review_gm_material: "S'ha fet malbé o perdut algun material?",
		review_gm_comments: "Comentaris o incidències?",
		staff_comments: "Comentaris",
		review_expectations: "Fins a quin punt els nostres serveis han complert les teves expectatives?",
		review_scale: "Del 1 al 10, quina probabilitat hi ha que recomanis els nostres serveis a algú del teu entorn?",
		review_gamemasters: "Com qualificaries l'atenció dels dinamitzadors durant l'activitat?",
		review_content: "Com qualificaries el contingut de l'activitat?",
		review_service_prices: "Com qualificaries el preu dels serveis?",
		review_previous_organization: "Com qualificaries l'organització prèvia a l'activitat?",
		review_hire_again: "Quines són les probabilitats que tornis a contractar el nostre servei?",
		review_comments: "Tens algun comentari o suggeriment per a nosaltres?",
		expected_not: "No han complert les meves expectatives",
		expected_more: "M'esperava més",
		expected_fulfilled: "Han complert amb el que esperava",
		expected_exceeded: "Han superat les meves expectatives",
		very_unsatisfactory: "Molt insatisfactòria",
		unsatisfactory: "Insatisfactòria",
		neutral: "Neutra",
		satisfactory: "Satisfactòria",
		very_satisfactory: "Molt satisfactòria",
		no_complaints: "No, moltes queixes",
		standing_group: "No gaire, grup aturat",
		generally_yes: "Generalment sí",
		highly_motivated: "Sí, grup molt motivat",
		staff_shortage_critic: "Feia falta personal críticament",
		staff_shortage: "Algún monitor més hagués estat bé",
		correct: "Correcte",
		staff_excess: "Sobrava personal",
		missing_information: "Faltava informació important",
		missing_details: "Faltaven alguns detalls",
		enough: "Suficient",
		surplus: "De sobres",
		early_expected: "Més d'hora del previst",
		on_point: "En punt",
		ten_late: "0-10 min tard",
		thirty_late: "10-30 min tard",
		more_late: "+30 min tard",
		user: "Usuari",
		timetable: "Horari",
		fundae: "FUNDAE",
		fundae_question: "Voleu bonificar aquesta activitat per FUNDAE? Qui ho gestiona?",
		fundae_option_no: "No",
		fundae_option_organization: "Sí, ho gestiona {name}",
		fundae_option_client: "Sí, ho gestiona el client",
		files_fundae_client: "Documentació FUNDAE (per al client a omplir)",
		files_fundae_client_by_client: "FUNDAE CLIENT — Documentació FUNDAE (per al client a omplir)",
		files_fundae_staff_tooltip:
			"Pugeu aquí el contracte d'encomiament degudament complimentat i signat. També la llista de participants emplenada.",
		files_fundae_staff: "Documentació FUNDAE (Emplenada per al client)",
		final_client_section: "Client final / Intermediari",
		final_client_section_tooltip:
			"Indica si el servei es contracta directament o mitjançant una agència, venue o un altre intermediari.",
		final_client_selector: "Ets client final o intermediari?",
		final_client_option_client: "Client final",
		final_client_option_agency: "Intermediari",
		final_client_name: "Nom del client final",
		final_client_agency: "Nom de l'intermediari",
		final_client_white_label:
			"L'equip dinamitzador pot acudir amb vestimenta corporativa o preferiu que la intervenció es realitzi en format de marca blanca?",
		bill_sent: "Factura enviada",
		custom_fields_section: "Camps personalitzats",
		contract_section: "Contracte",
		contract_status: "Contracte",
		contract_status_missing_data: "Falten dades",
		contract_status_pending_client: "Pendent del client",
		contract_status_pending_signature: "Per firmar",
		contract_status_signed: "Firmat",
		contract_status_inactive: "No activat",
		contract_status_signed_hidden: "Firmat (no activat)",
		contract_missing_keys: "Variables pendents",
		contract_not_activated_title: "Contracte no activat",
		contract_not_activated_hint: "El contracte no està activat en aquesta reserva. Activa'l perquè el client el pugui veure i firmar.",
		contract_show_to_client: "Activar contracte",
		contract_hide_from_client: "Desactivar contracte",
		contract_show_to_client_success: "Contracte activat",
		contract_hide_from_client_success: "Contracte desactivat",
		contract_reset: "Reiniciar contracte",
		contract_reset_confirm: "Es borraran la firma, el PDF firmat i tots els camps que hagi omplert el client. El client podrà tornar a completar-los i firmar. Vols continuar?",
		contract_reset_success: "Contracte reiniciat",
		contract_hint_pending_client: "El client ja pot veure el contracte al seu enllaç i completar els seus camps.",
		contract_hint_pending_signature: "Tot llest. El client pot firmar des del seu enllaç o descarregar el PDF.",
		contract_hint_signed: "El contracte ja està firmat. El pots descarregar des del menú ⋮.",
		contract_download_pdf: "Descarregar contracte PDF",
		contract_download_signed: "Descarregar contracte firmat",
		contract_fill_client_fields_hint: "Completa els camps marcats al contracte. Podràs firmar quan estiguin plens.",
		contract_fill_required_before_next: "Has d'omplir tots els camps abans de passar a la firma.",
		contract_fill_required_before_sign: "Has de completar el nom, els camps obligatoris i la firma abans de firmar.",
		contract_sign_choose_option: "Tria una de les dues opcions per firmar el contracte: firmar a la web o descarregar-lo i pujar-lo.",
		contract_sign_web: "Firmar a la web",
		contract_signer_name: "Nom del firmant",
		contract_clear_signature: "Netejar firma",
		contract_sign: "Firmar contracte",
		contract_sign_cta: "Firmar contracte",
		contract_continue: "Continuar contracte",
		contract_view: "Veure contracte",
		contract_minimize: "Minimitzar",
		contract_save_and_continue: "Desar i continuar a la firma",
		contract_finish_go_booking: "Finalitzar i anar a la reserva",
		contract_upload_signed: "Pujar contracte firmat",
		contract_upload_signed_hint: "Descarrega el PDF, firma'l i puja'l aquí.",
		contract_upload: "Pujar PDF",
		contract_upload_pdf_only: "Només es permeten fitxers PDF",
		contract_signed_success: "Contracte firmat correctament",
		filter_contract_status_label: "Estat del contracte",
		filter_contract_status_description: "Filtrar reserves per estat del contracte",
		contract_var_name: "Nom de la reserva",
		contract_var_date: "Data",
		contract_var_time: "Hora",
		contract_var_pax: "Persones",
		contract_var_language: "Idioma",
		contract_var_type: "Tipus (online/presencial)",
		contract_var_activity_duration: "Durada",
		contract_var_place_name: "Lloc",
		contract_var_place_url: "URL del lloc",
		contract_var_place_info: "Info del lloc",
		contract_var_place_contact: "Contacte del lloc",
		contract_var_billing_data: "Dades de facturació",
		contract_var_extra_info: "Info extra",
		contract_var_timetable_plain: "Horari",
		contract_var_team_number: "Nombre d'equips",
		contract_var_contact_persons: "Persones de contacte",
		contract_var_activities: "Activitats (economics)",
		contract_var_total_price: "Preu total (economics)",
		contract_var_budget_number: "Número de pressupost",
		contract_var_client_name: "Nom del client",
		contract_var_client_email: "Email del client",
		contract_var_signed_date: "Data de firma",
		contract_var_signed_time: "Hora de firma",
		client_information: "Informació del client",
		app: "App",
		event_details: "Detalls de l'esdeveniment",
		staff_persons: "Personal",
		incomes: "Ingressos",
		valoration_available: "VALORACIÓ (disponible al finalitzar l'esdeveniment)",
		very_likely: "Molt probable",
		likely: "Probable",
		unlikely: "Poc probable",
		very_unlikely: "Molt improbable",
		close_booking: " tancar Reserva",
		agency_files: "Arxius interns",
		client_files: "Arxius del client",
		client_files_tooltip:
			"Qualsevol arxiu necessari per a la realització de l'esdeveniment, com la llista de participants, horaris o altra documentació rellevant.",
		invoice_files: "Arxius de factura",
		event_invoice_files: "Factures de despeses de l'esdeveniment",
		upload_expense_invoice: "Pujar factura de despeses",
		upload_expense_invoice_modal_title: "Pujar factura de despeses",
		upload_expense_invoice_modal_hint:
			"Pots pujar una o diverses factures de despeses de l'esdeveniment. No podràs veure les factures pujades des d'aquí.",
		add_file: "Afegir arxiu",
		price_tag: "Etiqueta de preu",
		item: "Element de reserva",
		line: "Línia",
		pax: "Persones",
		auto_price: "Preu automàtic",
		done: "Finalitzades",
		canceled: "Cancel·lades",
		open: "Obertes",
		add_question_warning: "Les preguntes que afegeixis no es traduiran",
		place_contact: "Contacte de l'espai",
		place_contact_tooltip:
			"Dades de la persona responsable o de contacte de l'espai.",
		detail_canceled: "CANCEL·LADA",
		detail_open: "OBERTA",
		detail_closed: "CERRADA",
		status: "Estat",
		filter_dialog_title: "Filtrar reserves",
		filter_state_label: "Estat de la reserva",
		filter_state_description:
			"Mostra només reserves en els estats seleccionats (oberta, finalitzada o cancel·lada).",
		filter_owner_label: "Responsable de la reserva",
		filter_owner_description: "Filtra per la persona responsable de la reserva.",
		filter_main_staff_label: "Responsable de producció",
		filter_main_staff_description: "Filtra pel responsable de producció assignat a la reserva.",
		filter_fundae_label: "Subvenció FUNDAE",
		filter_fundae_description: "Si la reserva està marcada com a elegible per a finançament FUNDAE.",
		filter_fundae_files_label: "Documentació FUNDAE (Emplenada per al client) (2+ fitxers)",
		filter_fundae_files_description:
			"Mostra reserves que tenen almenys dos fitxers pujats a la documentació FUNDAE emplenada per al client.",
		filter_bill_sent_label: "Factura enviada",
		filter_bill_sent_description: "Si la factura ha estat marcada com a enviada per a la reserva.",
		filter_language_label: "Idioma de l'esdeveniment",
		filter_language_description: "Idioma configurat per a la reserva de l'esdeveniment.",
	
		crm_id_tooltip: "Identificador de l'oportunitat o reserva al vostre CRM extern. Si Pipedrive està connectat, es vincula al deal.",
		contact_person_tooltip: "Contacte principal del client per coordinar l'esdeveniment.",
		place_tooltip: "Nom de l'espai o lloc on se celebrarà l'esdeveniment.",
		url_location_tooltip: "Afegeix l'enllaç de Google Maps amb la ubicació exacta de l'esdeveniment.",
		extra_information_tooltip: "Informació general de context de l'esdeveniment.",
		auto_price_tooltip: "Calcula el preu utilitzant la tarifa configurada, l'etiqueta de preu i el nombre de participants.",
		bill_sent_tooltip: "Marca'l quan la factura s'hagi enviat al client.",
		responsible_tooltip: "Indica quin monitor serà el responsable principal de l'equip.",
		gm_valoration_tooltip: "Avaluació interna del monitor sobre el desenvolupament de l'activitat, l'equip i les possibles incidències.",
		client_valoration_tooltip: "Opinió del client sobre l'activitat, l'organització i el servei rebut.",
	},
	activities: {
		activities: "Activitats",
		activity: "App",
		game: "App",
		day: "Dia",
		enter: "Entrar",
		create_activity: "Crear Activitat",
		sure: "Estàs segur?",
		delete: "Eliminar",
		date_hour: "Data i hora",
		name_activity: "Nom de l'activitat",
		type_activity: "App",
		language: "Idioma",
		comments: "Comentaris",
		logo: "Logo",
		demo: "Demo",
		demo_locked_tooltip: "Un cop creat l'esdeveniment, no es pot canviar a demo ni treure el demo.",
		alert_name_activity: "Posa un nom a l'activitat.",
		select_language: "Selecciona un idioma",
		select_challenge: "Selecciona algun repte",
		select_date: "Selecciona una data",
		select_activity: "Selecciona un tipus d'activitat",
		select_name: "Posa un nom a l'activitat",
		select_primary_color: "Selecciona un color primari.",
		select_secondary_color: "Selecciona un color secundari.",
		save_error: "No s'ha pogut {message_request_negative} l'esdeveniment",
		save_ok: "Esdeveniment {message_request} correctament",
		delete_error: "No s'ha pogut eliminar l'esdeveniment",
		delete_ok: "S'ha eliminat l'esdeveniment",
		tl_activity: "Activitat {company}",
		click_add: "Fes clic per Afegir",
		dashboard: "Panell de control",
	
		demo_tooltip: "Marca'l per crear una activitat de demostració en lloc d'un esdeveniment real. Estarà limitada a 2 equips i no consumirà crèdits.",
	},
	demos: {
		demos: "Demos",
		create_demo: "Crear Demo"
	},
	content: {
		collabo: {
			presets: "Presets",
			preset: "Preset",
			challenges: "Reptes",
			challenge: "Repte",
			challenges_placeholder: "Seleccionar reptes",
			videos: "Vídeos Collabo",
			video_item: "Vídeo Collabo",
			videos_placeholder: "Seleccionar vídeos",
			videos_title: "Títol",
			description_gm: "Descripció per al monitor",
			video: "Vídeo",
			challenge_type: "Tipus de repte",
			challenge_type_placeholder: "Seleccionar tipus de repte",
			name: "Nom",
			material: "Material",
			materials: "Materials",
			materials_placeholder: "Seleccionar materials",
			construction: "Construcció",
			constructions: "Construccions",
			constructions_placeholder: "Seleccionar construccions",
			model3d: "Model 3D",
			paint: "Pintar",
			statment: "Declaració",
			make: "Fer",
			find: "Trobar",
			find_missing: "Trobar Faltant",
			image: "Imatge",
			subcontent: "Subcontingut",
			subcontent_placeholder: "p.ex., city_find, flower_pattern",
			description: "Descripció",
			placeholder_name_id: "Nom identificador del repte...",
			alert_name_id: "Posa un nom identificatiu al repte.",
			placeholder_description: "Descripció del repte..."
		},
		content: "Contingut",
		add_new_content: "Nou",
		discard_and_new_content: "Es perdran els canvis no desats. Vols crear un nou contingut?",
		list_content: "Llista de contingut",
		no_template: "Sense plantilla",
		no_act: "Sense cas",
		all: "Tots",
		downloading_content: "Descarregant contingut",
		skip_download: "Continuar sense esperar",
		skip_download_hint:
			"Pots continuar ara. La resta es descarregarà en segon pla quan hi hagi connexió.",
		background_download_remaining: "{count} pendents",
		background_download_in_settings: "Descarregant el contingut restant…",
		exporting_event_content: "Exportant enviaments dels jugadors",
		files_remaining: "fitxers restants",
		export_transferring_zip: "Iniciant descàrrega...",
		export_uploading_s3: "Pujant ZIP a l'emmagatzematge...",
		export_ready_downloading: "ZIP llest, iniciant descàrrega...",
		export_download_button: "Descarregar ZIP",
		player_asset_cache_title: "Preparant contingut sense connexió",
		player_asset_cache_text: "Desant mapes i fitxers al dispositiu per poder-los usar sense connexió.",
		cluedo_ai: {
			cluedo_ai_settings: "Plantilles",
			cluedo_ai_setting: "Configuració Cluedo AI",
			cluedo_ai_title: "Cluedo AI",
			cluedo_ai_act: "Cas",
			cluedo_ai_questions: "Preguntes",
			cluedo_ai_objects: "Objectes",
			cluedo_ai_characters: "Personatges",
			cluedo_ai_object: "Objecte",
			cluedo_ai_character: "Personatge",
			cluedo_ai_question: "Pregunta",
			duration: "Durada",
			placeholder_duration: "Durada de l'activitat",
			image_quiz: "Imatge qüestionari",
			image1: "Imatge 1",
			image2: "Imatge 2",
			image3: "Imatge 3",
			description: "Descripció",
			placeholder_description: "Descripció de l'activitat",
			name: "Nom",
			placeholder_name: "Nom de l'activitat",
			id_name: "Nom identificatiu",
			placeholder_id_name: "Nom identificatiu de l'activitat",
			alert_id_name: "Posa un nom identificatiu a l'activitat",
			templates: "Plantilles",
			act: "Cas",
			no_act: "Sense cas",
			setting: "Configuració",
			character: "Personatge",
			questions: "Preguntes",
			no_character: "Sense personatge",
			no_questions: "Sense preguntes",
			key_information: "Informació clau",
			placeholder_key_information: "Informació clau",
			placeholder_prompt: "Prompt",
			placeholder_prompt_answer: "Prompt resposta",
			placeholder_question: "Pregunta",
			placeholder_answer: "Resposta",
			placeholder_name_id: "Nom identificador del repte...",
			alert_name_id: "Pon un nom identificatiu al repte.",
			question: "Pregunta",
			answer: "Resposta",
			prompt_answer: "Prompt de resposta",
			points: "Punts",
			act_char: "Personatge",
			image: "Imatge",
			model3d: "Model 3D",
			prompt: "Prompt",
			start_message: "Missatge d'inici",
			placeholder_start_message: "Missatge d'inici",
			background: "Fons",
			add_key_information: "Afegir informació clau",
			age: "Edat",
			placeholder_age: "Edat del personatge",
			job: "Feina",
			placeholder_job: "Feina del personatge",
			personal_information: "Informació personal",
			placeholder_personal_information: "Informació personal del personatge",
			personality: "Personalitat",
			placeholder_personality: "Personalitat del personatge",
			context: "Context",
			placeholder_context: "Context del personatge",
			case_related: "Cas relacionat",
			placeholder_case_related: "Cas relacionat del personatge",
			motivation: "Motivació",
			placeholder_motivation: "Motivació del personatge",
			previous_knowledge: "Coneixements previs",
			placeholder_previous_knowledge: "Coneixements previs del personatge",
			relashionship: "Relacions",
			placeholder_relashionship: "Relacions del personatge",
			description_player: "Descripció del personatge",
			placeholder_description_player: "Descripció del personatge",
			short_text: "Text curt"
		},
		ipad: {
			ipad_settings: "Plantilles",
			ipad_setting: "Configuració Ipad",
			ipad_challenges: "Reptes digitals",
			must: "Obligatori",
			optional: "Opcional",
			first: "Primer",
			content_list: "Llista de Contingut",
			name: "Nom",
			setting: "Configuració",
			type: "Plantilla",
			quiz: "Qüestionari",
			open_text: "Text lliure",
			photo: "Foto",
			video: "Vídeo",
			alert: "Alerta",
			team_photo: "Foto d'equip",
			order: "Ordre",
			match: "Partit",
			type_challenge: "Tipus de repte",
			id_name: "Nom identificatiu",
			password: "Contrasenya",
			time: "Temps",
			challenge_close_time: "Temps per tancar",
			max_points: "Puntuació màxima",
			template: "Plantilla",
			description: "Descripció",
			file_1: "Fitxer 1",
			file_2: "Fitxer 2",
			file_3: "Fitxer 3",
			placeholder_type: "Selecciona un tipus",
			alert_type: "Selecciona un tipus de repte",
			placeholder_name_id: "Nom identificador del repte...",
			alert_name_id: "Posa un nom identificatiu al repte.",
			placeholder_name: "Nom del repte...",
			placeholder_password: "Contrasenya...",
			placeholder_description: "Descripció del repte...",
			expected_answer: "Resposta Esperada",
			placeholder_expected_answer: "Resposta esperada",
			challenge: "Repte digital",
			placeholder_team: "Equip..",
		
			template_tooltip: "Selecciona la plantilla base el contingut i la configuració de la qual es copiaran a la nova activitat.",
			must_tooltip: "Obliga a completar aquest repte en l'ordre de la ruta.",
			first_tooltip: "Fa que aquest repte aparegui al principi de l'experiència.",
			password_tooltip: "Codi que permet desbloquejar o validar l'accés al repte.",
			time_tooltip: "Temps disponible per completar el repte, en segons. És informatiu; en acabar el temps el repte no es tanca.",
			challenge_close_time_tooltip: "Segons mínims abans de poder prémer Continuar i tancar la prova.",
			max_points_tooltip: "Puntuació màxima que es pot aconseguir en completar el repte.",
		},
		tapas: {
			tapas_settings: "Plantilles",
			tapas_setting: "Configuració Tapas",
			change_time: "Modificar temps",
			tapas_challenges: "Reptes culinaris",
			tapas_challenge: "Repte culinari",
			ingredients: "Ingredients",
			ingredient: "Ingredient",
			item_shop: "Botiga",
			item_shop_item: "Botiga",
			name: "Nom",
			type: "Tipus",
			quiz: "Qüestionari",
			challenge: "Repte",
			type_challenge: "Tipus de repte",
			id_name: "Nom identificatiu",
			money: "Diners",
			template: "Plantilla",
			image: "Imatge",
			description: "Descripció",
			placeholder_type: "Selecciona un tipus",
			alert_type: "Selecciona un tipus de repte",
			placeholder_name_id: "Nom identificador del repte...",
			alert_name_id: "Posa un nom identificatiu al repte.",
			placeholder_name: "Nom del repte...",
			placeholder_description: "Descripció del repte...",
			setting: "Configuració",
			main_ingredient: "Ingredient principal",
			secondary_ingredient: "Ingredient secundari",
			decoration: "Decoració",
			base: "base",
			quantity: "Quantitat",
			quantity_placeholder: "Quantitat, Ej: 1 paquet 200gr...",
			objects_per_team: "Unitats per equip",
			once_per_team: "Només una compra per equip",
			object_shop: "Objecte Botiga",
			challenge_shop: "Repte Botiga",
		
			quantity_tooltip: "Quantitat o format de lliurament de l'ingredient, per exemple «1 paquet de 200 g».",
			objects_per_team_tooltip: "Defineix quantes unitats es calculen d'estoc base en relació amb el nombre d'equips.",
			once_per_team_tooltip: "Limita l'article a una sola compra per equip.",
		},
		utq: {
			challenges_utq: "Reptes",
			name: "Nom",
			placeholder_name: "Nom del repte...",
			id_name: "Nom identificatiu",
			material: "Material",
			placeholder_material: "Material...",
			description: "Descripció",
			placeholder_description: "Descripció del repte...",
			description_score: "Descripció Puntuació",
			placeholder_description_score: "Descripció de la puntuació del repte...",
			image: "Imatge",
			quiz: "Cuestionari",
			challenge: "Repte",
			placeholder_name_id: "Nom identificador del repte...",
			alert_name_id: "Posa un nom identificatiu al repte.",
			placeholder_descriptVideoinitial_challengesion_score: "Descripció del puntuació del repte...",
		
			material_tooltip: "Llista de materials necessaris per preparar i executar el repte.",
			description_score_tooltip: "Explica com s'ha d'avaluar i puntuar el repte.",
		},
		action: {
			action_settings: "Configuracions Action",
			action_setting: "Configuració Action",
			quiz: "Reptes de diners",
			category_quiz: "Categories de reptes de diners",
			category_quiz_item: "Categories de reptes de diners",
			challenge: "Reptes",
			challenge_item: "Repte",
			challenges: "Reptes",
			name: "Nom",
			category: "Categoria",
			type: "Tipus",
			setting: "Plantilla",
			init_challenge: "Repte inicial",
			init_challenges: "Reptes inicials i de botiga",
			order: "Ordenació",
			match: "Emparellament",
			quiz_multi: "Cuestionari multiresposta",
			text_auto: "Resposta autocorregida",
			text_data: "Resposta de text",
			type_challenge: "Tipus de repte",
			placeholder_type: "Selecciona un tipus",
			alert_type: "Selecciona un tipus de repte",
			id_name: "Nom identificatiu",
			placeholder_name_id: "Nom identificador del repte...",
			alert_name_id: "Posa un nom identificatiu al repte.",
			placeholder_name: "Nom del repte...",
			description: "Descripció",
			placeholder_description: "Descripció del repte...",
			image_quiz: "Imatge qüestionari",
			max_money: "Dinero màxim",
			need_material: "Necessita Material",
			material: "Material",
			placeholder_material: "Material necessari...",
			expected_answer: "Resposta Esperada",
			placeholder_expected_answer: "Resposta esperada",
			file_1: "Fitxer 1",
			file_2: "Fitxer 2",
			action_challenge_quiz: "Cuestionari",
			photo: "Foto",
			video: "Vídeo",
			team_photo: "Foto d'equip",
			template: "Plantilla",
			max_points: "Puntuació màxima",
			cost: "Cost",
			video_duration: "Durada del vídeo",
			short_description: "Descripció breu",
			placeholder_short_description: "Descripció breu...",
			help_gm: "Ajuda per puntuar",
			help_file: "Imatge Solució",
			internal_description: "Descripció interna",
			placeholder_internal_description: "Descripció del repte intern...",
			object_shop: "Botiga de construcció",
			object_shop_item: "Botiga de construcció",
			challenge_shop: "Reptes de construcció",
			challenge_shop_item: "Repte de botiga",
			text_data_auto: "Text per a correcció automàtica",
		
			max_money_tooltip: "Quantitat màxima de diners del joc que es pot obtenir.",
		},
		actionChallengeShopItem: {
			one_per_team: "Un per equip",
			two_per_team: "Dos per equip",
			one_per_two_teams: "Un cada dos equips",
			one_per_three_teams: "Un cada tres equips",
			identifying_name: "Nom Identificatiu",
			identifying_name_placeholder: "Nom identificatiu del qüestionari...",
			identifying_name_alert: "Posa un nom identificatiu al qüestionari.",
			image: "Imatge",
			cost: "Cost",
			max_per_team: "Màxim per equip",
			template: "Plantilla",
			default_material: "Material per defecte",
			material_description: "Descripció del material",
			name: "Nom",
			name_placeholder: "Nom del repte...",
			description: "Descripció",
			description_placeholder: "Descripció del repte...",
		
			max_per_team_tooltip: "Nombre màxim d'unitats que pot comprar cada equip.",
			default_material_tooltip: "Defineix quantes unitats es calculen d'estoc base en relació amb el nombre d'equips.",
		},
		bingo: {
			image_challenge_1: "Imatge de repte 1",
			image_challenge_2: "Imatge de repte 2",
			image_post_1: "Imatge de post 1",
			image_post_2: "Imatge de post 2",
			challenge_song: "Cançó de repte",
			winning_song: "Cançó de guanyador",
			bingo_challenges: "Reptes Bingo Musical",
			bingo_challenge: "Repte Bingo Musical",
			bingo_songs: "Cançons",
			bingo_song: "Cançó",
			bingo_sets: "Set",
			quiz: "Questionari",
			poll: "Enquesta",
			two_vs_two: "2 vs 2",
			challenge_type: "Tipus de repte",
			set: "Estableix",
			one_vs_all: "1 vs tots",
			image: "Imatge",
			fill: "Omplir",
			photo: "Foto",
			song_image: "Imatge de la cançó",
			set_image: "Imatge del set",
			song_file: "Fitxer de la cançó",
			challenge: "Reptes (es jugaran en ordre)",
			song_artist: "Artista",
			song_artist_placeholder: "Artista de la cançó...",
		
			challenge_song_tooltip: "Àudio utilitzat per introduir o acompanyar els reptes.",
			winning_song_tooltip: "Àudio que es reproduirà quan hi hagi un guanyador.",
		},
		common_sense: {
			challenges: "Reptes Common Sense",
			challenge: "Repte Common Sense",
			name: "Nom",
			settings: "Plantilles Common Sense",
			setting: "Plantilla Common Sense",
			id_name: "Nom identificatiu",
			name_placeholder: "Nom...",
			name_alert: "Afegeix un nom.",
			primary_color: "Color principal",
			personalization: "Personalització",
			theme: "Tema",
			challenges_title: "Challenges",
			client_personalization: "Personalització client",
			font_family: "Font",
			client_language: "Idioma del client",
			background_image: "Imatge de fons",
			theme_editable: "Tema editable",
			questions_editable: "Preguntes editables",
			questions_choose: "Preguntes seleccionables",
			flow_mode_enabled: "Flow activat per defecte",
			flow_order: "Ordre per defecte del Flow",
			flow_order_hint:
				"Selecciona primer els reptes de la plantilla i després arrossega'ls aquí per definir l'ordre per defecte.",
			challenge_type: "Tipus de repte",
			challenge_type_alert: "Selecciona un tipus de repte.",
			time_results: "Temps de resultats",
			questions: "Preguntes",
			quiz: "Quiz",
			fair_prize: "Preu just",
			timeline: "Timeline",
			questions_editor: {
				questions_count: "{type} · {count} preguntes",
				apply_time_to_all: "Aplicar temps a totes",
				add_question: "Afegir pregunta",
				no_questions_readonly: "Aquest repte no té preguntes.",
				no_questions_empty: "Afegeix la primera pregunta d'aquest repte Common Sense.",
				question_label: "Pregunta",
				answers_title: "Respostes (la primera és la correcta)",
				add_answer: "Afegir resposta",
				correct_answer_placeholder: "Resposta correcta",
				incorrect_answer_placeholder: "Resposta incorrecta {n}",
				fair_prize_correct_answer: "Resposta correcta",
				min_slider: "Mínim del slider",
				max_slider: "Màxim del slider",
				interval: "Interval",
				order_hint_start: "Indicació d'ordre (inici — esquerra / primer)",
				order_hint_end: "Indicació d'ordre (fi — dreta / últim)",
				order_hint_start_placeholder: "p. ex. Més antic, A dalt, Primer",
				order_hint_end_placeholder: "p. ex. Més recent, A baix, Últim",
				order_hint_help:
					"Es mostra als jugadors a cada extrem de la línia temporal per saber com ordenar (p. ex. antic → nou o a dalt → a baix).",
				correct_order: "Ordre correcte",
				add_item: "Afegir element",
				timeline_item_placeholder: "Element {n}",
				image: "Imatge",
				image_optional: "Imatge (opcional)",
				question_image: "Imatge de la pregunta",
				upload_image: "Pujar imatge",
				remove: "Treure",
				question_header: "Pregunta {n}",
				question_added: "Pregunta afegida",
				time_updated: "Temps actualitzat"
			}
		}
	},
	settings: {
		settings: "Plantilles",
		settings_list: "Llista de plantilles",
		ipad: {
			name: "Nom",
			id_name: "Nom identificatiu",
			placeholder_name_id: "Nom identificatiu del repte...",
			alert_name_id: "Posa un nom identificatiu al repte.",
			main_color: "Color principal",
			secondary_color: "Color secundari",
			stopwatch_color: "Color del cronòmetre",
			background_image: "Imatge de fons",
			points_icon: "Icona de punts",
			challenges: "Reptes",
			challenge: "Plantilla",
		
			main_color_tooltip: "Color principal utilitzat a la interfície de la plantilla.",
			secondary_color_tooltip: "Color secundari utilitzat per ressaltar elements de la interfície.",
			stopwatch_color_tooltip: "Color utilitzat per mostrar el temporitzador de l'activitat.",
			background_image_tooltip: "Imatge de fons que s'aplicarà a les pantalles dels reptes.",
			points_icon_tooltip: "Icona que representarà els punts obtinguts durant el joc.",
			challenges_tooltip: "Selecciona els reptes que estaran disponibles en aquesta plantilla.",
		},
		tapas: {
			name: "Nom",
			id_name: "Nom identificatiu",
			placeholder_name_id: "Nom identificador del repte...",
			alert_name_id: "Posa un nom identificatiu al repte.",
			secondary: "Secundaris",
			decoration: "Decoració",
			processing_time: "Temps d'elaboració",
			ingredients: "Ingredients",
			item_shop: "Botiga",
			tapas_challenges: "Reptes culinaris",
			keyword: "Plat",
			setting: "Plantilla",
			error_secondary_ingredients:
				"Si hi ha ingredients secundaris, has de seleccionar almenys un ingredient principal i un de secundari",
			error_missing_main_ingredient: "Falta almenys un ingredient principal a la plantilla",
			error_missing_secondary_ingredient: "Falta almenys un ingredient secundari a la plantilla",
			error_missing_main_and_secondary: "Falten ingredients principals i secundaris a la plantilla",
		
			secondary_tooltip: "Defineix quants ingredients secundaris apareixen a la selecció d'ingredients. Sempre hi ha 1 ingredient principal assignat aleatòriament.",
			ingredients_tooltip: "Selecciona els ingredients disponibles a la fase de selecció d'ingredient.",
			item_shop_tooltip: "Selecciona els articles que estaran disponibles a la botiga del joc.",
			keyword_tooltip: "Plat que es cuina en aquesta plantilla.",
		},
		action: {
			name: "Nom",
			id_name: "Nom identificatiu",
			placeholder_name_id: "Nom identificador del repte...",
			alert_name_id: "Posa un nom identificatiu al repte.",
			challenges: "Reptes",
			initial_shop_challenges: "Reptes inicials i de botiga",
			categories: "Categories de reptes de diners",
			challenge: "Plantilla",
			shop: "Botiga",
			construction_challenges: "Reptes de construcció",
			game_mode: "Mode de joc",
			menu_points: "Menú Punts",
			initial_challenges: "Reptes inicials",
			quiz: "Reptes de diners",
			menu_items: "Elements de menú",
			store_mode: "Construcció",
			contest_mode: "Concurs",
		
			game_mode_tooltip: "Tria si la plantilla s'utilitzarà a Contest App o Construction App; els camps dependents canviaran.",
			menu_items_tooltip: "Selecciona les seccions que apareixeran al menú de l'activitat.",
		},
		cluedo_ai: {
			primary_color: "Color principal",
			secondary_color: "Color secundari",
			timer_color: "Color cronòmetre",
			points_icon: "Icona de punts",
			name: "Nom",
			placeholder_name: "Nom del repte...",
			id_name: "Nom identificatiu",
			image: "Imatge",
			description: "Descripció",
			placeholder_description: "Descripció del repte...",
			acts: "Casos (L'ordre en què s'afegeixen serà l'ordre en què apareixeran)",
			settings: "Configuracions",
			setting: "Configuració"
		}
	},
	erp_settings: {
		exclude_web: "Excloure de web",
		category: "Categories",
		main_category: "Categoria principal",
		sub_category: "Categoria secundaria",
		create_sub_category: "Nova categoria",
		event_service: "Serveis d'esdeveniment",
		fixed: "Fix",
		add_price: "Afegir preu",
		location: "Ubicació",
		link_location: "Enllaç de la ubicació",
		placeholder_location: "Ubicació del servei d'esdeveniment",
		placeholder_link_location: "Enllaç de la ubicació del servei d'esdeveniment",
		event_service_name: "Nom del servei d'esdeveniment",
		placeholder_event_service_name: "Nom del servei d'esdeveniment",
		new_event_service: "Nou servei d'esdeveniment",
		link_app: "Enllaç App",
		youtube_url: "Enllaç de YouTube",
		placeholder_youtube_url: "Enllaç del vídeo de YouTube",
		organization: "Organització",
		name: "Nom",
		placeholder_name: "Nom",
		alert_name: "Ha de tenir un nom",
		logo: "Logo",
		default_image: "Imatge per defecte",
		color_primary_document: "Color principal de documents",
		color_secondary_document: "Color secundari de documents",
		billing: "Facturació",
		placeholder_billing: "Dades de facturació...",
		billing_mail: "Email de facturació",
		placeholder_billing_mail: "email@empresa.com",
		holded_contact_id: "ID contacte Holded",
		placeholder_holded_contact_id: "ID del contacte a Holded",
		vat_type: "Tipus d'IVA",
		vat_type_21: "21%",
		vat_type_exempt: "Exempt",
		gm_info_text: "Avís per a monitors / instructors",
		placeholder_gm_info_text: "Text que veuran els monitors en obrir una reserva...",
		list_activities: "Llista d'Activitats",
		new_activity: "Nova Activitat",
		search: "Cercar",
		placeholder_search: "Cercar per nom",
		in_person: "presencial",
		online: "En línia",
		modality: "Modalitat",
		alert_modality: "Selecciona una modalitat",
		general_media: "Mitjà",
		pricing_list: "Llista de preus",
		activity_name: "Nom",
		placeholder_activity_name: "Nom de l'activitat (Client)",
		duration: "Duració",
		placeholder_duration: "Duració de l'activitat",
		description: "Descripció",
		placeholder_description: "Descripció de l'activitat",
		requirements: "Requeriments",
		placeholder_requirements: "Requeriments de l'activitat",
		includes: "Inclou",
		placeholder_includes: "Què inclou l'activitat",
		dynamic: "Dinàmica",
		placeholder_dynamic: "Dinàmica de l'activitat",
		budget_description: "Descripció del pressupost",
		placeholder_budget_description: "Descripció del pressupost",
		media: "Media en aquest idioma",
		extras: "Extres",
		price: "Preu",
		activity: "Activitat",
		type_price: "Tipus de preu",
		alert_type_price: "Selecciona un tipus de preu",
		new_extra: "Nou Extra",
		preview_pdf: "Previsualitzar PDF",
		staff_document: "Document per a staff",
		extra_deleted: "S'ha eliminat l'extra",
		extra_not_deleted: "No s'ha eliminat l'extra",
		placeholder_name_extra: "Nom de l'extra",
		placeholder_description_extra: "Descripció de l'extra",
		extra: "Extra",
		total: "Total",
		by_person: "Per Persona",
		final_page_budget: "Pàgina final de pressupost",
		new_final_page_budget: "Nova pàgina final de pressupost",
		final_page_budget_deleted: "S'ha eliminat la pàgina final de pressupost",
		final_page_budget_not_deleted: "No s'ha pogut eliminar la pàgina final de pressupost",
		placeholder_description_activity: "Descripció de l'activitat",
		question: "Pregunta",
		placeholder_question: "Pregunta",
		all_activities: "Totes les activitats",
		no_activity: "Sense activitat",
		placeholder_activity: "Filtrar per activitat",
		questions_activities: "Preguntes sobre activitats",
		code: "Codi",
		placeholder_code: "Codi de l'activitat",
		question_booking: "Preguntes sobre reserves",
		new_question_booking: "Nova pregunta sobre reserves"
	},
	previews: {
		menu: "Menú"
	},
	login: {
		description: "Aplicació de {company} per a la realització d'esdeveniments de Team Building",
		email: "Email",
		placeholder_email: "Introdueix el teu email",
		password: "Contrasenya",
		placeholder_password: "Almenys 8 caràcters",
		sign_in: "Iniciar Sessió",
		invalid_credentials: "Credencials incorrectes",
		forgor_password: "Contrasenya oblidada"
	},
	formGenerator: {
		pricing: {
			new_price: "+ Nova línia de preu",
			min_persons: "Persones mínim",
			max_persons: "Persones màxim",
			total_price: "Preu total",
			person_price: "Preu persona",
			price: "Preu"
		}
	},
	dialogs: {
		close: "Tancar",
		sure: "Estàs segur?",
		erase: "Esborrar",
		erase_record: "Esborrar registre",
		delete_team: "Eliminar equip",
		confirm_delete_team: "Estàs segur que vols eliminar l'equip?",
		delete: "Eliminar",
		delete_colon: "Eliminar: ",
		cancel: "Cancel·lar",
		name: "Nom",
		add: "Afegir",
		placeholder_team: "Equip..",
		edit_team: "Editar equip",
		save: "Desar",
		demo_limit: "Les activitats de demo només permeten 2 equips",
		link_staff: "Enllaç Staff",
		link_admin: "Enllaç Administrador",
		link_results: "Enllaç de resultats",
		go_results: "Anar a resultats",
		add_team: "Afegir equip",
		material_recalculate: "En crear l'equip es recalcularà el material",
		material_tab_no_update_add_teams: "La pestanya de material no s'actualitzarà si afegeixes equips",
		warning: "Avís",
		add_team_money: "Afegir diners equip",
		link_teams: "Enllaç Equips",
		challenge_delete: "S'eliminarà el repte: ",
		create: "Crear",
		challenge: "Repte",
		item: "Article",
		stock: "Material",
		placeholder_challenge: "Selecciona un repte",
		warning_change_template: "En canviar la plantilla s'esborraran tots els reptes",
		team: "Equip",
		teams: "Equips",
		points_negative: "Punts (poden ser negatius)",
		money_negative: "Import (pot ser negatiu)",
		minutes: "Minuts",
		seconds: " segons",
		substract: "Restar",
		expected_answer: "Resposta esperada: ",
		challenge_score: "Puntuació repte",
		activate: "Activar",
		material_recalculate_delete: "En eliminar l'equip es recalcularà el material",
		add_route: "Afegir ruta",
		confirm: "Confirmar",
		accept: "Acceptar",
		activity: "Activitat",
		language: "Idioma",
		placeholder_language: "Selecciona un idioma",
		logo: "Logo",
		sure_delete_acitivty: "Estàs segur que vols esborrar l'activitat?",
		add_favorite: "Afegir a favorits",
		delete_favorite: "Treure de favorits",
		date: "Data",
		unsaved_changes_content: "Estàs segur?",
		unsaved_changes_title: "Es perdran els canvis no desats",
		stay: "Quedar-se",
		exit: "Sortir",
		client_validate: "Cal validar dades del client",
		close_booking: "Tancar reserva",
		cancel_reason: "Motiu de la cancel·lació",
		finish: "Finalitzar",
		favorite_challenge: "Favorit",
		object: "Objecte",
		character: "Personatge",
		key_information: "Informació clau",
		give: "Donar",
		key_information_done: "Informació clau completada",
		give_key_information: "Donar informació clau",
		team_components_precreated_only:
			"Els membres de l'equip només s'utilitzen en partides en línia, on els usuaris seleccionen el seu equip des de la pàgina d'equips.",
		team_components: "Components de l'equip",
		team_components_placeholder: "Afegeix un component i prem enter"
	},
	camera: {
		title_error_modal: "Error a la càmera",
		text_error_modal: "Avisar a la persona de staff per revisar la càmera. Error: ",
		btn_reload_app: "Recarregar aplicació",
		btn_load_foto: "Pujar foto des de la galeria",
		modal_upload_title: "Pujar Foto",
		modal_upload_text: "Pots pujar la teva foto des de la galeria",
		error_no_upload: "Has de pujar una foto primer",
		error_upload_photo: "Error al pujar la foto, torna-ho a intentar"
	},
	chat: {
		message: "Missatge",
		message_placeholder: "Escriu el teu missatge",
		message_btn: "Enviar missatge",
		send: "Enviat",
		read: "Llegit",
		new_message_summary: "Nou missatge de xat",
		new_message_detail: "Tens un nou missatge del STAFF"
	},
	customization: {
		common_sense: {
			subtitle: "Personalitza la teva experiència Common Sense",
			not_found: "Aquest enllaç de personalització no és vàlid.",
			tab_personalization: "Personalització",
			tab_create_content: "Crear contingut",
			challenges_selection: "Selecció de reptes",
			challenges_selection_hint:
				"Activa els reptes que vulguis utilitzar. Pots expandir cadascun per veure preguntes i respostes (només lectura).",
			challenges_view: "Reptes",
			challenges_view_hint:
				"Vista de només lectura. Expandeix cada repte per veure preguntes i respostes.",
			read_only_notice:
				"Aquest enllaç és de només lectura. Pots revisar el contingut però no modificar, activar ni afegir reptes.",
			no_challenges: "No hi ha reptes configurats en aquesta plantilla.",
			upload_image: "Pujar imatge",
			public_link: "Enllaç de personalització client",
			public_link_hint: "Comparteix aquest enllaç amb el teu client. Es genera en desar la plantilla.",
			challenges_client: "Reptes seleccionats pel client",
			no_questions: "No hi ha preguntes configurades.",
			untitled_question: "Pregunta sense títol",
			untitled_step: "Pas sense títol",
			correct: "correcta",
			correct_answer: "Resposta correcta",
			select_challenge: "Selecciona un repte",
			new_challenge: "Nou repte",
			add_challenge: "Afegir repte",
			challenge_added: "Repte afegit",
			challenge_name_required: "Indica un nom per al repte",
			delete_challenge: "Eliminar",
			delete_challenge_confirm_title: "Vols eliminar aquest repte?",
			delete_challenge_confirm_message:
				"S'eliminarà «{name}» d'aquesta plantilla. Aquesta acció no es pot desfer.",
			challenge_deleted: "Repte eliminat",
			nothing_enabled: "No hi ha opcions de personalització habilitades per a aquesta plantilla.",
			client_edit: "El client pot editar aquest repte",
			autosave_saving: "Desant…",
			autosave_saved: "Canvis desats",
			autosave_error: "No s'ha pogut desar. Torna-ho a provar.",
			challenges_client_hint: "Només pots triar retos que ja estiguin seleccionats a «Retos».",
			challenges_client_select_master_first:
				"Selecciona almenys un reto a «Retos» per poder configurar els retos del client."
		}
	},
	gm: {
		modals: {
			add_monitor: "+ Afegir monitor",
			save: "Desar",
			name: "Nom del monitor",
			placeholder_name: "Nom del monitor",
			saved_monitor: "Monitor desat",
			continue: "Continuar",
			change: "Canviar",
			exit: "Sortir",
			cancel: "Cancel·lar",
			exit_event: "Sortir de l'esdeveniment",
			password: "Contrasenya",
			enter_name: "Introdueix el teu nom"
		},
		ranking: {
			show: "Ensenyar Ranking",
			hide: "Amagar Ranking"
		},
		dashboards: {
			teams: "Equips",
			credits_to_consume: "Crèdits a consumir",
			unit_cost: "cost unitari",
			links: "Enllaços",
			name: "Nom de l'equip",
			chat: "Missatges",
			configuration: "Configuració general",
			configuration_activity: "Configuració d'activitat",
			link_ranking: "Classificació d'enllaços",
			link_results: "Enllaç de resultats",
			link_monitors: "Enllaç Monitors",
			link_admin: "Enllaç Admin",
			link_presentation: "Enllaç Presentació",
			link_teams: "Enllaç Equipos",
			list_ingredients: "Llista d'ingredients",
			link_favorite_images: "Enllaç Imatges favorites",
			total: "Total",
			remaining: "Restant",
			round_ends: "La ronda finalitza en",
			round: "Ronda",
			play: "Jugar",
			resume: "Continuar",
			pause: "Pausar",
			pass_round: "Saltar Ronda",
			time_ranking: "Veure temps en ranking",
			results: "Resultats",
			add_team: "Afegir Equip",
			add_teams: "Afegir Equips",
			order_points: "Ordenar ranking per punts",
			add_challenges_first: "Afegeix reptes primer",
			general: "General",
			material: "Material",
			event_configuration: "Configura l'esdeveniment abans de seguir",
			back: "Enrere",
			save: "Desa",
			challenges: "Reptes",
			score_categories: "Categories de puntuació",
			defense: "DEFENSA",
			presentation: "PRESENTACIÓ",
			flavor: "Sabor",
			money: "Dinero",
			round_time: "Durada en minuts",
			tapas_time: "Temps de cuina",
			round_time_minutes: "Temps per ronda en minuts",
			type: "Plantilla",
			placeholder_type: "Selecciona un tipus",
			setting_logo_replace_title: "Vols fer servir el logo de la plantilla?",
			setting_logo_replace_message:
				"L'esdeveniment ja té un logo. Vols mantenir l'actual o fer servir el logo configurat pel client a la plantilla?",
			setting_logo_keep_event: "Mantenir logo de l'esdeveniment",
			setting_logo_use_setting: "Fer servir logo de la plantilla",
			ingredient: "Ingredients",
			shop: "Botiga",
			select_challenge: "Selecciona algun repte",
			select_activity: "Selecciona una activitat",
			select_time_round: "Posa un temps per ronda",
			select_time_tapas: "Posa un temps per realitzar les tapes",
			select_categories: "Si us plau selecciona les categories",
			team_turn: "Torn de l'equip",
			type_election: "Tipus d'elecció",
			round_election: "Ronda d'elecció",
			round_total: "Ronda total",
			time_elaboration: "Temps d'elaboració",
			name_team: "Posa un nom a l'equip",
			number_teams: "Número d'equips",
			total_ingredients: "Total d'ingredients",
			extra_ingredients: "Ingredients extres",
			total_decoration: "Total decoració",
			extra_decoration: "Decoració extra",
			missing_ingredients: "Falten ingredients",
			list_download: "Descarregar Llista",
			ingredients: "Ingredients",
			saved: "Guardat",
			start_game: "Començar Joc",
			gm: "Monitor",
			monitors: "Monitors",
			monitors_visible: "Monitors visibles",
			monitors_hidden: "Monitors ocults",
			readed: "Llegit",
			sent: "Enviat",
			message_team: "Escriu un missatge a l'equip",
			message_all_teams: "Els missatges que escriguis s'enviaran a tots els equips",
			your_message: "El teu missatge",
			upload_image: "Pujar imatge",
			add_emoji: "Afegir emoticon",
			send_message: "Enviar missatge",
			all: "Tots els equips",
			challenge: "Repte",
			id_name: "Nom identificatiu",
			latitude: "Latitud",
			longitude: "Longitud",
			activations_radius: "Radi d'activació",
			categories_points: "Categories de puntuació",
			must_upper: "OBLIGATORI",
			first_upper: "PRIMER",
			type_activation: "Tipus d'activació",
			qr_upper: "QR",
			qr_code: "Codi QR",
			location_upper: "UBICACIÓ",
			first: "Primera",
			must: "Obligatòria",
			add_challenges: "Afegir reptes",
			select_latitude: "Selecciona una latitud",
			select_longitude: "Selecciona una longitud",
			placeholder_id_name: "Posa un nom identificatiu",
			placeholder_template: "Selecciona una plantilla",
			put_duration: "Posa una durada",
			initial_position: "Posició inicial",
			not_template: "Sense plantilla",
			template: "Plantilla",
			placeholder_search_address: "Cerca una adreça...",
			drag_drop_image: "Arrossega i deixa caure una imatge aquí",
			or_click_upload: "o fes clic per pujar",
			no_image: "No hi ha imatge disponible",
			duration_seconds: "Duració (minuts)",
			duration_hours: "Durada en hores",
			duration_minutes: "Durada en minuts",
			categories: "Categories de reptes de diners",
			time_action: "Posa un temps per realitzar els reptes",
			routes: "Rutes",
			team_no_route: "Hi ha equips sense ruta",
			changes_not_saved: "Canvis no desats",
			route: "Ruta",
			order: "Ordre: ",
			name_route: "Nom",
			placeholder_name_route: "Nom de la ruta",
			event: "Esdeveniment",
			select_setting: "Selecciona una configuració",
			initial_challenges: "Reptes Inicials",
			time_higher_zero: "El temps ha de ser més gran que 0",
			time_required: "El temps per ronda és necessari",
			time_integer: "El temps ha de ser un nombre sencer",
			warning_template: "Si no tries una plantilla hauràs de crear tots els reptes manualment.",
			add_teams_first: "Abans d'afegir material has d'afegir equips",
			acts: "Casos",
			placeholder_acts: "Selecciona un cas",
			qr_codes: "Codis QR",
			objects: "Objectes",
			characters: "Personatges",
			type_game: "Tipus de joc",
			team_mode: "Configuració d'equips",
			alert_team_mode: "Selecciona una configuració d'equips",
			team_mode_on_the_fly: "Equips al vol",
			team_mode_on_the_fly_desc:
				"Els jugadors entren primer al lobby i els equips es creen després. Aquest mode pot funcionar amb ubicacions (per agrupar o identificar jugadors per taula, sala, ciutat, seu, etc.) o sense ubicacions (tots els jugadors entren i després es creen els equips).",
			team_mode_precreated: "Equips precreats",
			team_mode_precreated_desc:
				"Utilitza el sistema actual de Teaming App, on els equips ja estan creats prèviament abans d'iniciar la partida.",
			map_configuration: "Configuració del mapa",
			finish_latitude: "Latitud final",
			finish_longitude: "Longitud final",
			map: "Mapa",
			init: "Inici",
			finish: "Fi",
			online: "En línia",
			presential: "Presencial",
			hybrid: "Híbrid",
			game_image: "Pujar la foto que veuran els jugadors a la seva app",
			sets: "Sets",
		
			finish_position: "Posició final",
			template_tooltip: "Selecciona la plantilla base el contingut i la configuració de la qual es copiaran a la nova activitat.",
			presential_tooltip: "Utilitza aquesta opció quan participants i monitors siguin al mateix espai. La música es reprodueix a la pantalla pública.",
			online_tooltip: "Utilitza aquesta opció quan els participants es connectin a distància. La música es reprodueix a la vista del jugador.",
			type_game_tooltip: "Defineix com es desbloquegen els reptes: QR requereix escanejar codis i no cal configurar un mapa; Map utilitza ubicacions i geolocalització per activar-los per proximitat.",
			online_mode_tooltip: "La investigació es realitza sense ubicacions físiques ni codis QR. Els personatges i objectes comencen desbloquejats.",
			qr_upper_tooltip: "Els equips desbloquegen les proves escanejant codis QR. No cal configurar un mapa.",
			map_tooltip: "Els equips utilitzen el mapa i la geolocalització per trobar les proves.",
			initial_position_tooltip: "Defineix el punt de referència al voltant del qual se situaran inicialment totes les proves. També s'estableix com a punt final de l'activitat, encara que després es pot modificar.",
			finish_position_tooltip: "S'estableix com a punt final de l'activitat, encara que després es pot modificar.",
			all_teams: "Tots els equips",
		},
		utq: {
			change_monitor: "Canviar Monitor",
			round: "Ronda",
			ends: "Finalitza",
			start: "Iniciar joc",
			team_upper: "Equip",
			position_upper: "Posició",
			points_upper: "Punts",
			team: "Equip",
			placeholder_team: "Selecciona un equip",
			score: "Puntuació",
			rate: "Puntuar",
			instructions_material: "Instruccions i material",
			name_event: "Posa un nom a l'esdeveniment",
			select_team: "Selecciona un equip",
			operation: "Funcionament",
			material: "Material"
		},
		tapas: {
			disponible_later: "Disponible més endavant",
			round_ends: "La ronda finalitza en",
			score_missing: "Queden reptes sense puntuar als equips",
			start_challenges: "Iniciar reptes",
			start_selection: "Començar Selecció d'Ingredients",
			start_elaboration: "Començar Temps d'Elaboració",
			pass_round: "Saltar Ronda",
			selecting_ingredients: "Seleccionant ingredients",
			pass_selection: "Saltar selecció",
			team_turn: "Torn de l'equip",
			type_selection: "Tipus de selecció",
			round_selection: "Ronda de selecció",
			round_total: "Ronda total",
			votes: "Votacions",
			type_choice: "Tipus d'elecció",
			top_1: "Top 1",
			top_2: "Top 2",
			top_3: "Top 3",
			round: "Ronda",
			time_eleboration: "Temps d'elaboració",
			start: "Iniciar joc",
			challenges: "Reptes",
			placeholder_challenge: "Selecciona un repte i prem començar",
			orders: "Encàrrecs",
			change_money: "Modificar diners",
			shop: "Botiga",
			challenges_results: "Resultats dels reptes",
			ingredient_selection: "Selecció d'ingredients",
			winners: "Guanyadors",
			placeholder_select_team: "Selecciona un equip",
			category: "Categoria",
			rate: "Puntuació",
			defense: "Defensa",
			show: "Presentació",
			flavour: "Sabor",
			change_main_ingredient: "Canviar Ingredient Principal",
			challenges_done: "Reptes realitzats"
		},
		ipad: {
			time_game: "Temps de joc",
			start_game: "Començar Joc",
			add_delete_time: "Afegir/Treure Temps",
			hide_ranking: "Amagar Ranking",
			show_ranking: "Ensenyar Ranking",
			lock_challenges: "Bloquejar Reptes",
			unlock_challenges: "Desbloquejar Reptes",
			move_challenges: "Moure proves",
			challenges: "Reptes",
			clean_filters: "Esborrar filtres",
			add_delete_points: "Ajustar punts",
			activate_challenge: "Activar repte",
			no_route: "Sense Ruta",
			instructor: "Monitor",
			player: "Jugador",
			team: "Equip",
			points: "Punts",
			challenges_done: "Reptes Realitzats",
			last_challenge: "Últim Repte",
			hour: "Hora",
			must: "Obligatoris",
			optionals: "Opcionals",
			status_not_started: "No començat",
			status_started: "Començat",
			status_pending: "En camí",
			status_done: "Completat",
			select_team_to_view_challenges: "Selecciona un equip per veure els seus reptes"
		},
		action: {
			next_challenge: "Forçar repte",
			start: "Iniciar joc",
			next: "Següent",
			time_game: "Temps de joc",
			start_game: "Començar Joc",
			add_delete_time: "Afegir/Eliminar Temps",
			ranking: "Ranking",
			finish_game: "Finalitzar Joc",
			reactivate_game: "Reactivar Joc",
			challenges: "Reptes",
			clean_filters: "Esborrar filtres",
			team_filter: "Filtre Equip",
			challenge_filter: "Filtre Repte",
			add_delete_points: "Ajustar punts",
			add_delete_money: "Ajustar diners",
			activate_quiz: "Activar Qüestionari",
			ranking_normal: "Normal",
			ranking_coop: "Cooperatiu",
			ranking_both: "Ambdós",
			ranking_hidden: "Amagat",
			ranking_slides: "Diapositives",
			activate_challenge: "Activar repte",
			show_videos: "Imatges Finals",
			select_action: "Estat",
			quizzes: "Questionaris",
			challenge_not_start: "Encara no ha començat cap repte",
			challenges_pick: "Reptes a recollir",
			challenges_return: "Reptes a retornar",
			challenges_material: "Material reptes",
			update_stock: "Modificar Stock",
			update_initial_stock: "Modificar estoc inicial",
			picked_challenges: "Reptes Seleccionats",
			fake_upload: "Càrrega Falsa",
			no_picked_challenges: "No hi ha reptes recollits disponibles",
			stock_upper: "STOCK: ",
			stock_initial_upper: "ESTOC INICIAL: 2",
			stock: "Stock",
			team_upper: "Equip",
			challenge_upper: "RETO",
			returned_upper: "DEVOLUT",
			delivered_upper: "ENTREGAT",
			team: "Equip",
			points: "Punts",
			money: "Diners",
			quizzes_done: "Preguntes Realitzades",
			challenges_done: "Reptes Realitzats",
			last_challenge: "Últim Repte",
			material: "Material",
			save: "Desar",
			material_to_pick: "Material a recollir",
			stock_shop: "Estoc de la botiga",
			delivery: "Entregat",
			challenge_started: "Repte iniciat",
			error_start_challenge: "Error en iniciar el repte",
			challenge_flash: "Reto Flash",
			add_favorite: "Afegir a favorits",
			delete_favorite: "Eliminar de favorits",
		
			ranking_slides_tooltip: "Imatges que es poden mostrar a la pantalla del ranking per explicar o començar el joc.",
			stock_tooltip: "Nombre d'unitats disponibles per comprar per defecte.",
		},
		cluedo_ai: {
			pause_game: "Pausa Joc",
			resume_game: "Reanudar Joc",
			no_chat: "No hi ha xat",
			game_done: "Joc finalitzat. Dirigeix-te al punt de trobada final.",
			act_information: "Informació del cas",
			characters: "Personatges",
			objects: "Objectes",
			key_informations: "Informació clau",
			chat: "Missatges",
			ranking: "Ranking",
			configuration: "Opcions",
			start_game: "Començar Joc",
			next_act: "Següent Cas",
			add_points: "Afegir Punts",
			add_time: "Afegir Temps",
			give_object: "Donar Article",
			give_information: "Donar Informació",
			questions: "Preguntes",
			team: "Equip",
			points: "Punts",
			objects_found: "Articles trobats",
			characters_found: "Personatges trobats",
			questions_answered: "Preguntes respostes",
			position: "Posició",
			add_delete_time: "Afegir/Treure Temps",
			add_delete_points: "Ajustar punts",
			participants_answer: "Resposta participants",
			correct_answer: "Resposta correcta",
			score: "Puntuació",
			feedback: "Feedback",
			not_evaluated: "Sense avaluar",
			edit_question: "Editar pregunta",
			last_act: "Últim cas",
			evaluated: "Avaluat",
			confirm_start_game: "Segur que vols començar el joc?",
			confirm_next_act: "Segur que vols passar al cas següent?",
			confirm_last_act: "Segur que vols finalitzar l'últim cas?",
		
			character_name_alt: "Nom del sospitós",
			object_name_alt: "Nom de l’objecte",
		},
		collabo: {
			double_materials_mode: "Mode de Materials Duplicats",
			material_multiplier_title: "Multiplicador de materials",
			material_multiplier_configure: "Configurar multiplicador",
			material_multiplier_next_distribution: "S'aplicarà al proper repartiment de materials.",
			material_multiplier_updated: "Multiplicador de materials actualitzat correctament",
			material_multiplier_x1_hint: "Ideal per a més de 30 pax",
			material_multiplier_x2_hint: "Ideal per a 20 a 30 pax",
			material_multiplier_x3_hint: "Ideal de 10 a 20 pax",
			material_multiplier_x4_hint: "Menys de 10 pax",
			double_materials_mode_on: "Activat",
			double_materials_mode_off: "Desactivat",
			stage_give_material: "Donar Material",
			select_team: "Seleccionar Equip",
			select_material: "Seleccionar Material",
			enter_quantity: "Introduir Quantitat",
			give_material: "Donar Material",
			material_given_success: "Material donat correctament",
			material_given_error: "Error al donar el material",
			material: "Material",
			double_materials_mode_updated: "Mode de Materials Duplicats actualitzat correctament",
			quantity: "Quantitat",
			controls: "Controls",
			total_teams: "Total d'equips",
			teams_list: "Llista d'equips",
			start_game: "Iniciar joc",
			no_teams: "No hi ha equips",
			start_final_construction_round: "Inicia la ronda final de construcció",
			final_construction_round_started: "Ronda final de construcció iniciada",
			game_started: "Joc iniciat correctament",
			game_start_error: "Error al iniciar el joc",
			challenges_status: "Estat de Reptes",
			confirmed_teams: "Equips Confirmats",
			total_points: "Punts Totals",
			correct_answer: "Resposta Correcta",
			team_removed_from_challenge: "Equip eliminat del repte",
			team_remove_from_challenge_error: "Error en eliminar equip del repte",
			construction_phase_started: "Fase de construcció iniciada",
			construction_phase_error: "Error en iniciar fase de construcció",
			construction_phase: "Fase de Construcció",
			constructions_in_progress: "Construccions En Procés",
			no_constructions_in_progress: "No hi ha construccions en procés",
			building_type: "Tipus de Construcció",
			leading_team: "Equip Líder",
			helping_teams: "Equips Ajudants",
			completed_constructions: "Construccions Completes",
			no_completed_constructions: "No hi ha construccions completes",
			remaining_materials: "Materials Restants",
			construction_phase_finished: "Fase de construcció finalitzada",
			construction_phase_finish_error: "Error al finalitzar fase de construcció",
			team: "Equip",
			position: "Posició",
			points: "Punts",
			chat: "Missatges",
			ranking: "Ranking",
			configuration: "Opcions",
			go_to_construction: "Ir a Fase de Construcció",
			finish_construction_phase: "Finalitzar Fase de Construcció",
			show_teams: "Mostrar Equips",
			hide_teams: "Ocultar Equips",
			unsaved_changes: "Tens canvis sense desar",
			save: "Desar",
			number_of_challenges: "Sets de reptes",
			link_teams: "Enllaçar Equips",
			link_monitors: "Enllaçar Monitors",
			link_staff: "Enllaç Staff",
			add_team: "Afegir Equip",
			add_teams: "Afegir Equips",
			materials: "Materials",
			no_materials: "No hi ha materials",
			constructions: "Construccions",
			no_constructions: "No hi ha construccions",
			challenges: "Reptes de materials",
			no_challenges: "No hi ha reptes",
			round_time: "Temps de ronda de reptes en minuts",
			minutes: "Minuts",
			round_time_placeholder: "Introdueix el temps de ronda en minuts",
			challenge_time: "Temps de ronda de construcció en minuts",
			challenge_time_placeholder: "Introdueix el temps de construccio en minuts",
			game_mode: "Mode de Joc",
			teams: "Equips",
			individual: "Individual",
			quantity_by_team: "Quantitat per equip",
			enter_quantity_by_team: "Introduir quantitat per equip",
			total: "Total",
			ranking_title: "Títol de la ciutat",
			ranking_title_placeholder: "Títol mostrat a la pantalla pública del rànquing",
			player_answer: "Resposta del jugador",
			solution: "Solució",
			players_response: "Resposta dels equips",
			view_all_constructions: "Veure totes",
			all_completed_constructions: "Totes les construccions completades",
			all_constructions_ordered_by_last_done: "Llista ordenada per la construcció més recent primer.",
			constructions_of_type_ordered_by_last_done:
				"Totes les construccions d'aquest tipus, ordenades per la més recent primer.",
			order: "#",
			total_rounds: "Total de rondes",
			undo_final_construction_round: "Desfer ronda final de construcció",
			confirm_start_final_construction_round: "Segur que vols canviar al mode final de construcció?",
			confirm_undo_final_construction_round: "Segur que vols desfer el mode final de construcció?",
			final_construction_round_undone: "Ronda final de construcció desfeta",
		
			ranking_title_tooltip: "Títol que es mostrarà a la pantalla pública del ranking.",
			individual_tooltip: "Cada participant juga des del seu propi mòbil i accedeix a l'activitat mitjançant un codi QR.",
			teams_tooltip: "Els participants juguen en equips fixos i comparteixen una tablet durant tota l'activitat.",
			number_of_challenges_tooltip: "Defineix quants jocs complets de reptes s'utilitzaran. Per a esdeveniments de més de 50 participants.",
		},
		common_sense: {
			controls: "Controls",
			total_teams: "Total d'equips",
			no_teams: "No hi ha equips",
			start_game: "Iniciar joc",
			pause_game: "Pausar Joc",
			resume_game: "Reprendre Joc",
			show_final_ranking: "Mostrar rànquing final",
			game_final_ranking: "Rànquing final",
			game_status_final_ranking: "Rànquing final",
			final_ranking_shown: "Rànquing final mostrat",
			game_resumed: "Joc reprès",
			game_running: "Joc en curs",
			game_paused: "Joc en pausa",
			teams_list: "Llista d'equips",
			game_started: "Joc iniciat correctament",
			game_start_error: "Error en iniciar el joc",
			ranking: "Ranking",
			challenge_ranking: "Rànquing del repte",
			ranking_your_team: "El teu equip",
			ranking_leaderboard: "Classificació",
			ranking_points_abbr: "pts",
			ranking_number_header: "N.º",
			team: "Equip",
			position: "Posició",
			points: "Punts",
			phase: "Fase",
			roulette: "Ruleta",
			roulette_stage_title: "Desafiaments de la ruleta d'equip",
			select_challenge: "Selecciona un repte",
			challenge_started_times: "({count}×)",
			roulette_start: "Començar",
			public_rules_show: "Mostrar normes a la pantalla pública",
			public_rules_hide: "Amagar normes a la pantalla pública",
			roulette_hint: "Selecciona un repte i comença la ruleta.",
			flow_mode: "Mode Flow",
			flow_mode_hint: "Ordena els reptes i desa perquè l'instructor només hagi de prémer Següent.",
			flow_instructor_hint:
				"Activa el Flow per avançar amb Següent. Pots ajustar l'ordre i els boosters abans de continuar si cal fer canvis d'última hora.",
			flow_event_hint:
				"Defineix l'ordre del flow per a aquest esdeveniment. El podràs canviar en directe si cal.",
			flow_remove_challenge: "Treure repte del flow",
			flow_restore_all: "Restaurar tots",
			flow_restore_selected: "Usar reptes seleccionats",
			flow_position: "Posició",
			flow_no_booster: "Sense booster",
			flow_configure: "Configurar Flow",
			flow_enabled: "Flow actiu",
			flow_disabled: "Flow inactiu",
			flow_challenge_progress: "Joc {current} de {total}",
			skip_flow_challenge: "Saltar repte",
			skip_flow_challenge_confirm:
				"Segur que vols saltar aquest repte? Si està en curs passarà a la pantalla principal; si encara no ha començat s'ometrà del flow sense mostrar-se als jugadors.",
			skip_flow_challenge_done: "Repte saltat",
			next: "Següent",
			advance_phase: "Avançar fase",
			finish_challenge: "Finalitzar repte",
			finish_ranking: "Finalitzar rànquing",
			reset_to_waiting_challenge: "Tornar a triar repte",
			reset_to_waiting_challenge_confirm:
				"Tornaràs a la fase d'espera (ruleta) sense mostrar el rànquing del repte ni completar les rondes pendents. Els punts ja assignats en rondes anteriors es mantenen.",
			reset_to_waiting_challenge_done: "Fase reiniciada: pots triar un nou repte",
			add_substract_points: "Sumar / restar punts",
			points_hint: "Fes servir valors negatius per restar.",
			boosters: "Boosters",
			booster_half_time: "Meitat de temps",
			booster_points_x2: "Punts x2",
			select_booster: "Selecciona un booster",
			apply_booster: "Aplicar booster",
			roulette_challenge_image_alt: "Imatge del repte: {name}",
			roulette_challenge_default: "Repte {id}",
			roulette_show_badge: "REPTE",
			public_no_challenges: "No hi ha reptes configurats per a aquest esdeveniment.",
			public_loading: "Carregant…",
			public_waiting_game: "Esperant que l'amfitrió iniciï el joc.",
			public_waiting_challenge: "Quan l'amfitrió tregui un repte, la ruleta es reproduirà aquí.",
			player_menu_play: "Joc",
			player_menu_settings: "Ajustos",
			instructor_menu_controls: "Controls del joc",
			instructor_menu_ranking: "Ranking",
			instructor_menu_settings: "Opcions",
			ranking_team_fallback: "Equip {id}",
			public_challenge_rules: "Normes del repte",
			public_no_rules_text: "No hi ha text de normes configurat per a aquest repte.",
			challenge_play_subphase: "Pas del repte {n}",
			in_challenge_phase_waiting: "Esperant repte",
			in_challenge_phase_rolling: "Ruleta",
			in_challenge_phase_showing_rules: "Mostrant normes",
			in_challenge_phase_playing: "Repte en joc",
			in_challenge_phase_result: "Resultat del repte",
			in_challenge_phase_ranking: "Rànquing",
			in_challenge_phase_unknown: "Fase desconeguda",
			challenge_subphase_progress: "{current} de {total}",
			challenge_subphase_of: "de",
			phase_code: "Fase {code}",
			challenge_no_active: "No hi ha cap repte actiu seleccionat.",
			challenge_fair_prize_play: "Repte de preu just — pantalla de joc",
			challenge_quiz_play: "Repte tipus qüestionari — pantalla de joc",
			challenge_timeline_play: "Repte de línia temporal — pantalla de joc",
			timeline_no_rounds: "No hi ha rondes de línia temporal configurades per a aquest repte.",
			timeline_question_heading: "Ordena els passos",
			timeline_order_hint: "Ordena les targetes. Pots canviar l'ordre fins que s'acabi el temps.",
			timeline_order_context_aria: "Com ordenar la línia temporal",
			timeline_position: "{n}",
			timeline_question_label: "Pregunta {n}",
			timeline_timer_aria: "Temps restant",
			phase_timer_question: "Temps",
			phase_timer_results: "Temps",
			timeline_steps_aria: "Passos a ordenar",
			timeline_submit_answer: "Enviar ordre",
			timeline_answer_submitted: "Ordre enviada",
			timeline_result_intro: "El teu ordre i els punts de cada targeta.",
			timeline_result_round_label: "Punts d'aquesta ronda",
			timeline_result_no_movement: "No has fet cap moviment.",
			timeline_result_total: "+{n} pts",
			timeline_result_points: "+{n}",
			timeline_result_correct: "Correcte",
			timeline_result_semi: "Gairebé",
			timeline_result_wrong: "Incorrecte",
			timeline_result_should_be: "Ordre correcte: {n}",
			timeline_public_result_hint: "Ordre correcte de la seqüència.",
			timeline_public_team_hits: "Encerts d'equip: {n}",
			timeline_public_perfect_order: "Ordre perfecte",
			timeline_public_perfect_score: "({correct}/{total})",
			quiz_no_questions: "No hi ha preguntes de qüestionari configurades per a aquest repte.",
			quiz_question_heading: "Pregunta",
			quiz_answers_aria: "Opcions de resposta",
			quiz_select_answer: "Tria la teva resposta",
			quiz_submit_answer: "Enviar resposta",
			quiz_answer_submitted: "Resposta enviada",
			quiz_change_until_time_end: "Pots canviar la teva resposta fins que s'acabi el temps.",
			quiz_result_teams_pct: "{count}/{total} · {pct}%",
			quiz_waiting_play: "Espera que l'instructor iniciï la ronda del repte.",
			fair_prize_question_heading: "Pregunta",
			fair_prize_slider_aria: "Control lliscant de rang de preu",
			fair_prize_range_from: "Des de",
			fair_prize_range_to: "Fins a",
			fair_prize_your_guess: "La teva estimació",
			fair_prize_select_value: "Arrossega el control per indicar la teva millor resposta",
			fair_prize_submit_answer: "Enviar resposta",
			fair_prize_answer_submitted: "Resposta enviada",
			fair_prize_change_until_time_end: "Pots canviar la teva estimació fins que s'acabi el temps.",
			fair_prize_no_questions: "No hi ha rondes de preu just configurades per a aquest repte.",
			fair_prize_correct_answer: "Resposta correcta",
			fair_prize_result_your_guess: "La teva estimació",
			fair_prize_result_no_adjustment: "No has ajustat la teva estimació.",
			fair_prize_legend_correct: "Correcta",
			fair_prize_legend_your_team: "El teu equip",
			fair_prize_legend_others: "Altres",
			fair_prize_all_team_answers: "Respostes de tots els equips",
			fair_prize_no_team_answers: "Encara no hi ha respostes dels equips",
			fair_prize_teams_count: "{n} equips",
			fair_prize_teams_label: "equips",
			quiz_correct_answer: "Resposta correcta",
			challenge_result_badge: "Resultat",
			rules_fair_prize_badge: "Repte de preu just",
			rules_timeline_badge: "Repte de línia temporal",
			rules_quiz_badge: "Repte tipus qüestionari",
			rules_section_kicker: "Repte",
			rules_quiz_type: "Opció múltiple",
			rules_timeline_type: "Ordenar",
			rules_fair_prize_type: "Estimació",
			rules_quiz_intro:
				"{count} preguntes. Respon abans que s'acabi el temps: com més ràpid encertis, més punts suma el teu equip.",
			rules_timeline_intro:
				"{count} rondes d'ordenació. Col·loca els passos en la seqüència correcta abans que s'acabi el temps.",
			rules_fair_prize_intro:
				"{count} rondes d'estimació. Endevina el valor més proper abans que s'acabi el temps.",
			rules_quiz_demo_title: "Toca una resposta",
			rules_quiz_demo_hint:
				"Prem la targeta de color que creguis correcta. Pots canviar la resposta fins que s'acabi el temps.",
			rules_timeline_demo_title: "Arrossega per ordenar",
			rules_timeline_demo_hint:
				"Mantén premuda cada targeta i arrossega-la amunt o avall fins deixar la seqüència correcta. Pots canviar l'ordre fins que s'acabi el temps.",
			rules_timeline_step_a: "Pas A",
			rules_timeline_step_b: "Pas B",
			rules_timeline_step_c: "Pas C",
			rules_fair_prize_demo_title: "Ajusta el número",
			rules_fair_prize_demo_hint:
				"Deslitza el control o usa els botons − i + per afinar la teva estimació. Guanya qui s'hi acosti més.",
			player_challenges_heading: "Els teus reptes",
			player_challenges_subtitle: "Tria un repte quan l'amfitrió el activi a la ruleta per jugar.",
			player_challenge_active_now: "Actiu ara",
			player_challenge_not_active:
				"Aquest repte encara no està actiu. Espera que l'amfitrió el tregui a la ruleta.",
			player_challenge_open_play: "Jugar ara",
			player_challenge_view_details: "Veure detalls",
			player_back_to_challenges: "Tots els reptes"
		},
	
		forms: {
			please_input: "Introdueix una quantitat",
		
			please_select: "Selecciona una opció",
			please_select_filter: "Selecciona un filtre",
		},
	},
	errors: {
		required: "Aquest camp és obligatori",
		invalid_email: "L'email no és vàlid",
		invalid_url: "L'URL no és vàlida",
		invalid_number: "El número no és vàlid",
		field_invalid: "Camp {field} incorrecte",
		connection: "Error de connexió amb el servidor",
		unauthorized: "No tens permís per fer aquesta acció",
		not_found: "No s'ha trobat el registre",
		conflict: "Ja existeix un registre amb aquestes dades",
		server: "S'ha produït un error al servidor"
	},
	messages: {
		error_generating_pdf: "No s'ha pogut generar el PDF",
		join_game_success: "Has entrat al joc correctament",
		success: "Èxit",
		download_completed: "Descàrrega Completada",
		error: "Error",
		error_downloading: "No s'ha pogut descarregar el fitxer",
		game_paused: "Joc pausat",
		game_resumed: "Joc reanudat",
		round_pass: "Ronda saltada",
		canceled: "Cancel·lat",
		deleted: "Eliminat",
		updated: "Actualitzat",
		added: "Afegit",
		monitor_added: "Monitor afegit correctament",
		monitor_updated: "Monitor actualitzat correctament",
		monitor_not_added: "No s'ha pogut afegir al monitor",
		score_ok: "Puntuació enviada correctament",
		score_not_ok: "No s'ha pogut enviar la puntuació",
		score_add: "Posa una puntuació",
		select_team: "Selecciona un equip",
		team_error: "No s'ha pogut afegir l'equip",
		team_correctly: "Equip {msg} correctament",
		incorrect_fields: "Hi ha camps incorrectes al formulari",
		tapas_succesfull_updated: "Activitat Guerra de Tapas actualitzada correctament",
		tapas_not_succesfull_updated: "No s'ha pogut actualitzar l'activitat Guerra de Tapas",
		tapas_succesfull_added: "Activitat Guerra de Tapas afegida correctament",
		tapas_not_succesfull_added: "No s'ha pogut afegir l'activitat Guerra de Tapas",
		select_passed: "Selecció saltada",
		link_copied: "Enllaç copiat",
		votes_deleted: "Vots eliminats correctament",
		votes_not_deleted: "No s'han pogut eliminar els vots",
		money_updated: "Dinero actualitzat",
		teams_added: "Equips afegits correctament",
		game_started: "Joc començat",
		deleted_ok: "Eliminat correctament",
		deleted_not_ok: "No s'ha pogut eliminar",
		updated_not_ok: "No s'ha pogut actualitzar",
		select_challenge: "Selecciona un repte",
		challenges: "Reptes",
		template: "Plantilla",
		ipad_hunt_not_succesfull_added: "No s'ha pogut afegir l'activitat Ipad Hunt",
		challenge_activated: "Repte activat",
		points_updated: "Punts actualitzats",
		time_updated: "Temps actualitzat",
		correctly_scored: "Puntuat correctament",
		incorrectly_scored: "No s'ha pogut puntuar correctament",
		team: "Equip",
		action_updated_ok: "Activitat Action Challenge actualitzada correctament",
		action_updated_not_ok: "No s'ha pogut actualitzar l'activitat Action Challenge",
		action_added_ok: "Activitat Action Challenge afegida correctament",
		action_added_not_ok: "No s'ha pogut afegir l'activitat Action Challenge",
		route_created: "Ruta creada",
		route_deleted: "Ruta esborrada",
		route_saved: "Ruta guardada",
		saved: "Desat",
		select_category: "Escollir una categoria",
		must_select: "Has de seleccionar top1 i top 2",
		vote_sent: "Votació enviada",
		vote_error: "Error al votar",
		correct_score: "Puntuat Correctament",
		incorrect_score: "No s'ha pogut puntuar correctament",
		game_reactivated: "Joc Reactivat",
		game_finished: "Joc Finalitzat",
		write_quesiton: "Escriu una pregunta",
		event_deleted: "Esdeveniment esborrat",
		select_activity: "Has de seleccionar l'activitat",
		event_created: "Esdeveniment creat",
		event_updated: "Esdeveniment editat",
		event_not_created: "No s'ha pogut crear l'esdeveniment",
		utq_updated: "Activitat Rally actualitzada correctament",
		utq_not_updated: "No s'ha pogut actualitzar l'activitat Rally",
		url_copied: "URL copiada",
		url_error: "Error al copiar la URL",
		error_deleting_event: "No s'ha pogut eliminar l'esdeveniment",
		reopened: "Reobert",
		finished: "Finalitzat",
		cancelled: "Cancel·lat",
		closed_booking: "Reserva tancada",
		canceled_booking: "Reserva cancel·lada",
		file_removed: "Arxiu eliminat",
		upload_file: "Pujar arxiu",
		file_uploaded: "Arxiu pujat",
		error_upload: "No s'ha pogut pujar l'arxiu",
		no_id_model: "Cal desar el formulari abans de pujar arxius",
		no_files_readonly: "De moment no hi ha arxius per descarregar.",
		favorite_challenge_added: "Repte afegit a favorits",
		favorite_challenge_removed: "Repte eliminat de favorits",
		next_act: "Següent cas",
		added_points: "Punts afegits",
		added_time: "Temps afegit",
		given_object: "Objecte donat",
		given_information: "Informació donada",
		write_question: "Escriu una pregunta"
	},
	player_views: {
		event: {},
		home: {
			user_registered: "Usuari registrat",
			active_events: "Veure esdeveniments actius",
			insert_code: "Introduir codi esdeveniment // equip",
			qr_scan: "Escanejar QR",
			code_event: "Codi esdeveniment",
			code_team: "Codi equip",
			event_not_exist: "L'esdeveniment no existeix",
			team_not_exist: "L'equip no existeix"
		},
		player_view: {}
	},
	public_views: {
		tapas: {
			presentation_tapas: {
				end: "Fi de la presentació"
			},
			ranking_tapas: {
				round_ends: "Ronda finalitza",
				team_turn: "Torn equip",
				choice_type: "Tipus elecció",
				choice_round: "Ronda elecció",
				total_round: "Ronda total",
				time_preparation: "Temps d'elaboració"
			},
			results_tapas: {}
		},
		utq: {
			ranking_utq: {
				round_ends: "Ronda finalitza",
				points_upper: "PUNTS",
				points_abbr: "pts",
				challenge_upper: "REPTE",
				challenges_done: "Reptes",
				team_upper: "EQUIP",
				team_fallback: "Equip",
				position_upper: "POSICIÓ",
				round_time_left: "Temps restant ronda",
				no_teams: "Encara no hi ha equips al rànquing"
			},
			results_utq: {
				team_upper: "EQUIP",
				position_upper: "POSICIÓ",
				points_upper: "PUNTS"
			}
		},
		collabo: {
			last_buildings: "Últimes Construccions",
			buildings: "Construccions",
			join_event: "Unir-me a l'esdeveniment",
			next_objective: "Següent objectiu",
			all_objectives_completed: "Tots els objectius completats",
			objective: "Objectiu",
			objective_completed: "S'ha completat l'objectiu",
			new_buildings_unlocked: "NOUS EDIFICIS DESBLOQUEJATS",
			skyscraper_unlocked: "Ja podeu construir el gratacels",
			ranking_title_default: "Rànquing"
		},
		team_picker: {
			title: "Llista d'equips",
			tooltip: "Genera un enllaç perquè els equips puguin escollir en quin equip volen participar",
			subtitle: "Troba i visualitza equips buscant per nom o ID",
			search_placeholder: "Cerca per nom o ID d'equip...",
			no_teams_found: "No s'han trobat equips",
			try_adjusting_search: "Intenta ajustar la teva cerca",
			no_teams_available: "No hi ha equips disponibles",
			showing_results: "Mostrant {count} de {total} equips",
			points: "Punts",
			id: "ID"
		},
		event_lobby: {
			title: "Sala d'espera",
			join_game: "Entrar al joc",
			player_photo_optional: "Foto del jugador (Opcional)"
		},
		actionChallenge: {
			ranking_action_challenge: {
				press_button_view_ranking: "PRem el botó per veure el rànquing",
				view_ranking: "Veure rànquing"
			}
		}
	},
	ipadHunt: {
		ipadHunt_player: {
			must_challenge: "Repte obligatori",
			modal_password: "Escriu la contrasenya que et proporcionarà el membre del STAFF",
			modal_error_download_title: "Contingut no guardat",
			modal_error_download_text: "Torna a descarregar el contingut",
			modal_download_content_title: "Descarregant contingut",
			modal_download_content_text: "Descarregant contingut",
			modal_error_location_title: "No està disponible la localització",
			modal_error_location_text:
				"Activa els permisos de localització o posa't en contacte amb l'organitzador de l'esdeveniment.",
			content_correct: "Contingut descarregat correctament",
			content_incorrect: "Hi ha errors en el contingut, torna a descarregar",
			delete_content: "Tornar a descarregar el contingut",
			test_camera: "Prova la càmera",
			answer_send:
				"La vostra resposta s'ha registrat correctament. En els pròxims minuts rebreu els punts corresponents.",
			match: "Relacionar",
			take_photo: "Fer foto",
			take_video: "Gravar vídeo",
			error_wrong_password: "La contrasenya és incorrecta",
			error_no_answer: "No s'ha detectat cap resposta",
			error_order: "Has d'ordenar les respostes",
			modal_test_title: "PROVA",
			modal_test_localization_correct: "Localització correcta",
			modal_test_localization_incorrect: "La localització no està disponible",
			modal_test_ok: "Test correcte",
			reload_app: "Actualitzar aplicació",
			challenge_camera: "Càmera repte",
			modal_challenge_title: "PROVA",
			modal_challenge_localization_correct: "Localització correcta",
			modal_challenge_localization_incorrect: "Localització no disponible",
			modal_challenge_ok: "Repte completat correctament",
			reset_challenge: "Reiniciar repte inicial",
			challenge_reset: "Repte reiniciat correctament",
			no_active_challenge: "No s'ha trobat cap repte actiu",
			show_start_challenges: "Mostrar Reptes Inicials",
			start_challenges_shown: "Els Repte(s) es mostraran novament",
			no_start_challenges: "No s'han trobat reptes inicials",
			scan_qr: "Escanejar QR",
			qr_scanned: "Codi QR escanejat!",
			error_invalid_qr: "Codi QR invàlid",
			error_challenge_not_found: "Repte no disponible",
			error_challenge_already_done: "Aquest repte ja està completat",
			challenges_blocked: "Reptes bloquejats",
			challenges_blocked_message:
				"El monitor ha bloquejat tots els reptes. Si us plau, espera que es desbloquegin els reptes."
		},
		game_master_ranking: {
			name: "Nom",
			points: "Punts",
			challenges_done: "Reptes realitzats",
			last_challenge: "Últim repte"
		},
		initial_position: "Posició inicial",
		finish_position: "Posició final",
	
		initial_position_tooltip: "Defineix el punt de referència al voltant del qual se situaran inicialment totes les proves. També s'estableix com a punt final de l'activitat, encara que després es pot modificar.",
		finish_position_tooltip: "S'estableix com a punt final de l'activitat, encara que després es pot modificar.",
	},
	actionChallenge: {
		actionChallenge_player: {
			final_images: "Imatges del joc",
			already_done: "Ja has fet aquesta prova",
			quiz_already_done: "Ja has fet aquest qüestionari",
			category_completed: "Ja has fet tots els qüestionaris d'aquesta categoria",
			until: "Fins a",
			points: "Punts",
			coins: "monedes",
			coins_won: "Monedes guanyades:",
			audio_error: "El teu navegador no suporta el format d'àudio.",
			need_material: "En aquest repte necessites material",
			continue: "CONTINUAR",
			send_response: "ENVIAR RESPUESTA",
			correct_response: "RESPUESTA CORRECTA",
			correct_responses: "RESPUESTES CORRECTES",
			incorrect_response: "RESPUESTA INCORRECTA",
			money_won: "Dinero guanyat:",
			response: "Resposta",
			multiple_answers_hint: "( PODEU SELECCIONAR DIVERSAS RESPOSTES )",
			btn_match: "Match",
			successes: "Aciertos",
			similarity: "La paraula coincideix un {similarity_percentage}% amb les paraules correctes",
			category_no_elements: "No hi ha elements en aquesta categoria",
			not_started: "L'ESDEVENIMENT ENCARA NO HA COMENÇAT",
			challenge_warning: "Després de comprar un repte, ves a buscar el material a la botiga per completar-lo.",
			pick_material: "VES A BUSCAR EL MATERIAL A LA BOTIGA PER COMENÇAR AQUEST REPTE",
			challenge_send: "LA RESPONSE HA ESTAT ENVIADA I SERÀ AVALUADA PER L'INSTRUCTOR",
			return_material: "DEVOL TOTAL MATERIAL A LA BOTIGA PER SELECCIONAR EL SEGÜENT REPTE",
			points_won: "Punts guanyats",
			wrong_answer: "RESPUESTA INCORRECTA",
			game_finished: "LA PARTIDA HA FINALITZAT",
			return_material_finish: "DEVOL TOTAL MATERIAL DEL REPTE A LA BOTIGA",
			no_material: "En aquests moments no hi ha material suficient per fer aquest repte",
			no_money: "No tens diners suficients per comprar aquest repte",
			shop: "Botiga",
			obejcts_buy: "Material comprat",
			quantity: "Quantitat",
			modal_buy_text: "Comprar {object} per {dinero}$",
			error_item_buy_no_money: "No tens prou diners",
			error_item_buy_no_stock: "No queda estoc",
			error_item_buy_can_not_more: "No pots comprar més material d'aquest tipus",
			ok_item_buy: "Material comprat, ja pots recollir-lo",
			construction_name: "Nom de la construcció",
			construction_photo: "Foto de la construcció",
			total_points: "Punts totals",
			ranking_hidden: "El rànquing està amagat",
			ranking_cooperative: "Rànquing cooperatiu",
			ranking_slides: "Diapositives"
		},
		ranking_action_challenge: {
			press_button_view_ranking: "Prem el botó per veure el rànquing",
			view_ranking: "Veure rànquing"
		}
	},
	cluedo_ai: {
		cluedo_ai_player: {
			game_paused: "El joc està pausat, espera que el monitor el torni a activar.",
			evaluated: "Respostes Avaluades",
			upload_team_picture: "Pujar foto d'equip",
			no_picture: "No hi ha foto d'equip",
			scan_qr_code: "Escanejar QR",
			key_information: "Informació clau",
			key_information_missing: "Falta Informació clau",
			no_key_information: "No hi ha informació clau",
			objects: "Objectes",
			characters: "Personatges",
			game_intro: "Introducció del cas",
			question: "Pregunta",
			game_finished: "Joc finalitzat",
			questions_modified: "Respostes sense guardar",
			init_conversation: "Envia un missatge per iniciar la conversa amb {character_name}",
			interrogate: "Interrogar",
			explore: "Explorar",
			view_intro: "Veure introducció",
			send_answer: "Desar respostes",
			conclusions: "Conclusions",
			not_started: "El joc encara no ha començat",
			updated: "Respostes actualitzades",
			answers_sent: "Respostes enviades",
			answers_not_sent: "No s'han pogut enviar les respostes",
			no_answer: "No hi ha resposta",
			new_object_unlocked: "Nou objecte desbloquejat",
			new_character_unlocked: "Nou personatge desbloquejat",
			model_3d: "Model 3D",
			answer_placeholder: "Resposta...",
			voice_record: "Parlar (prem per gravar i un altre cop per transcriure)",
			voice_stop: "Aturar gravació i transcriure",
			voice_listening: "Escoltant…",
			voice_transcribing: "Transcrivint àudio…",
			voice_error_microphone_unavailable: "El micròfon no està disponible en aquest dispositiu.",
			voice_error_microphone_denied: "Permís de micròfon denegat.",
			voice_error_empty_recording: "No s'ha gravat àudio.",
			voice_error_empty_transcript: "No s'ha entès l'àudio.",
			voice_error_transcription_failed: "No s'ha pogut transcriure l'àudio. Torna-ho a provar.",
			found_object: "HAS TROBAT UN OBJECTE",
			found_character: "HAS TROBAT UN PERSONATGE",
			error_invalid_qr: "Codi QR invàlid",
			error_wrong_case_title: "Cas incorrecte",
			error_wrong_case_message: "Aquest codi QR pertany a un altre cas. Només es poden escanejar codis QR del cas actiu en aquest moment."
		}
	},
	collabo: {
		player_collabo: {
			seconds_to_show_error_modal: "Espera {seconds} segons",
			error: "Error",
			incorrect_answer: "Resposta incorrecta. Si us plau, torna-ho a intentar.",
			correct: "Correcte",
			correct_answer: "Resposta correcta",
			last_buildings: "Últimes Construccions",
			buildings: "Construccions",
			join_challenge: "Estic en {challenge_name}",
			go_zone: "VES A LA ZONA DEL REPTE <span class='text-primary'>{challenge_name}</span> PER COMENÇAR.",
			confirm_join_challenge:
				"Confirmes que estàs al roll-up de <span class='text-primary'>{challenge_name}</span> amb els teus companys?",
			players_joined: "Jugadors",
			cancel: "Cancel·lar",
			confirm_join: "Confirmar",
			points_added: "Punts afegits correctament",
			points_add_error: "Error en afegir punts",
			challenge_joined: "T'has unit al repte correctament",
			challenge_join_error: "Error al unir-se al repte",
			construction_in_progress: "Construcció En Procés",
			material_needed: "Material Necessari",
			delete_construction: "Eliminar Construcció",
			cancel_construction: "Cancel·lar Construcció",
			join_construction: "QR per unir-se",
			material_in_construction: "Material en construcció:",
			available: "Disponible",
			in_construction: "En Construcció",
			player_join: "Unir-se Jugador",
			helpToBuild: "Ajudar a Construir",
			build: "Construir",
			not_enough_materials: "Edificis Insuficients",
			build_construction: "Construir Edifici",
			build_construction_description: "Vols començar a construir aquest edifici?",
			new_material_received: "Nou Material Rebut",
			accept: "Acceptar",
			join_construction_description: "Escaneja el codi QR per unir-te a aquesta construcció",
			delete_construction_description: "Estàs segur que vols eliminar aquesta construcció?",
			delete: "Eliminar",
			cancel_construction_description: "Estàs segur que vols cancel·lar l'ajuda amb aquesta construcció?",
			construction_finished: "Construcció Finalitzada",
			construction_finished_description: "La construcció ha estat completada!",
			success_construction: "Construcció Exitosa",
			building_id: "ID de l'Edifici",
			built_by: "CONSTRUÏT PER",
			just_now: "Ara",
			some_minutes_ago: "Fa {minutes} minuts",
			more_than_hour_ago: "Fa menys d'una hora",
			minute_ago: "MIN",
			minutes_ago: "MIN",
			hour_ago: "H",
			hours_ago: "H",
			day_ago: "DIA",
			days_ago: "DIES",
			material_accepted: "Material acceptat correctament",
			material_accept_error: "Error en acceptar material",
			material_added: "Material afegit correctament",
			material_add_error: "Error en afegir material",
			construction_canceled: "Construcció cancel·lada correctament",
			construction_cancel_error: "Error en cancel·lar construcció",
			construction_deleted: "Construcció eliminada correctament",
			construction_delete_error: "Error en eliminar construcció",
			construction_started: "Construcció iniciada correctament",
			construction_error: "Error en iniciar construcció",
			enter_number: "Introduir Número",
			submit: "Enviar",
			select_color: "Seleccionar Color",
			select_color_first: "Si us plau, selecciona un color primer",
			saving: "Desant...",
			no_recipe: "No hi ha recepta disponible",
			your_components: "Els Teus Components",
			component_updated: "Component actualitzat correctament",
			matrix_updated: "Matriz actualitzada correctament",
			matrix_update_error: "Error en actualitzar la matriz",
			your_resources: "Els teus recursos",
			or_enter_code: "O introdueix el codi:",
			enter_3_letters: "Introdueix 3 lletres",
			validate_code: "Validar Codi",
			invalid_code: "Codi incorrecte",
			code_not_found: "El codi no correspon a cap construcció disponible",
			code_label: "Codi:",
			objective_done: "Objectiu complert",
			teams_in_construction: "Equips a la construcció",
			participants_in_construction: "Participants a la construcció",
			leading_team: "Líder"
		}
	},
	tapas: {
		change_main_ingredient: "Canviar ingredient principal",
		change_time: "Modificar temps",
		tapas_player: {
			change_name: "Canviar nom",
			time_choose: "Temps per escollir",
			presentation_in: "Presentació en",
			final_presentation: "Presentació final",
			default_keyword: "Paraula clau",
			dish_name_PC: "Nom de la paella",
			dish_name_Tapas: "Nom de la tapa",
			dish_name_MS: "Nom de la sangria",
			dish_name: "Nom de ",
			dish_photo: "Foto de ",
			dish_photo_PC: "Foto de la paella",
			dish_photo_Tapas: "Foto de la tapa",
			dish_photo_MS: "Foto de la sangria",
			available_money: "Dinero disponible",
			choose_ingredient: "Escollir ingredient",
			team_choosing: "Equip escollint",
			choose_rice: "Escollir arroces",
			choose_plates: "Escollir plats",
			choose_plates_rices: "Escollir plats/arroces",
			choose_decoration: "Escollir decoració",
			change_team_name: "Canviar nom d'equip",
			buy_confirm: "Confirmar compra",
			meal_photo: "Foto del menjar",
			exit_event: "Sortir de l'esdeveniment",
			answer_correct: "La resposta és correcta",
			answer_incorrect: "La resposta és incorrecta",
			name_changed: "Nom canviat",
			name_sent: "Nom enviat",
			item_purhased: "Objecte comprat, ja pots anar a recollir-lo a la botiga",
			no_unit: "No hi ha unitats",
			password_incorrect: "La contrasenya no és correcta",
			item_purchased: "Utensili comprat",
			item_already_purchased: "El teu equip ja ha comprat aquest article",
			team_photo: "Foto d'equip",
			ingredient_history: "Historial d'Ingredients",
			current_ingredients: "Ingredients Actuals",
			shop_items: "Articles de la Botiga",
			team_info: "Informació de l'Equip",
			team_name: "Nom de l'Equip",
			current_money: "Diners Actuals",
			not_set: "No establert",
			new_challenge: "Nou repte"
		}
	},
	modals: {
		upload_photo: {
			change_camera: "Canviar càmera",
			upload_photo: "Pujar foto",
			photo_success: "Foto enviada"
		}
	},
	stores: {
		tapas: {
			main_ingredient: "Ingredient principal",
			global_winner: "Global",
			flavour_winner: "Sabor",
			presentation_winner: "Present.",
			defense_winner: "Defensa",
			money_winner: "Dinero",
			photo_tapa: "F. TAPA",
			photo_team: "F. EQUIP",
			tapa: "TAPA",
			position: "POSICIÓ",
			points: "PUNTS"
		}
	},
	erp: {
		booking: {
			reservation: "Reserva",
			client_link: "Enllaç client",
			changes_pending: "Canvis pendents de validar",
			changes_sent_title: "Canvis desats",
			changes_sent_detail: "Els teus canvis s'han desat i enviat correctament. Ara estan pendents de validació.",
			changes_sent_no_changes: "No hi havia canvis nous per enviar.",
			calendar: {
				vendedor: "Venedor",
				produccion: "Producció",
				select_vendedor: "Seleccionar venedor",
				select_produccion: "Seleccionar producció",
				calendar: "Calendari",
				filters: "Filtres",
				calendar_filters: "Filtres del calendari",
				production_details: "Detalls producció",
				configure_fields: "Configurar camps",
				crm_id: "ID CRM",
				pax: "Pax",
				language: "Idioma",
				fundae: "FUNDAE",
				staff_number: "Número de monitors",
				teams_number: "Número d'equips",
				bookings: "Reserves",
				budgets: "Pressupostos",
				gamemasters: "Monitors",
				accepted: "ACCEPTAT",
				to_check: "PER REVISAR"
			}
		},
		user_settings: {
			title: "Configuració d'Usuari",
			change_password: "Canviar Contrasenya",
			new_password: "Nova Contrasenya",
			enter_new_password: "Introdueix la nova contrasenya",
			confirm_password: "Confirmar Contrasenya",
			confirm_new_password: "Confirmeu la nova contrasenya",
			change_password_button: "Canviar Contrasenya",
			change_language: "Canviar Idioma",
			language: "Idioma",
			select_language: "Seleccioneu un idioma",
			change_language_button: "Canviar Idioma",
			password_required: "Si us plau, introduïu la nova contrasenya",
			password_min_length: "La contrasenya ha de tenir almenys 8 caràcters",
			confirm_password_required: "Si us plau, confirmeu la nova contrasenya",
			passwords_not_match: "Les contrasenyes no coincideixen",
			password_changed_success: "Contrasenya canviada amb èxit.",
			password_change_error: "Error en canviar la contrasenya. Si us plau, torneu-ho a intentar.",
			form_errors: "Si us plau, corregeix els errors en el formulari.",
			spanish: "Espanyol",
			english: "Anglès",
			language_required: "Si us plau, seleccioneu un idioma",
			language_updated_success: "Idioma actualitzat amb èxit.",
			language_update_error: "Error en actualitzar l'idioma. Si us plau, torneu-ho a intentar.",
			select_valid_language: "Si us plau, seleccioneu un idioma vàlid."
		},
		configuration: {
			integrations: {
				title: "Integracions",
				subtitle: "Connecta eines externes amb la teva organització.",
				connected: "Connectat",
				not_connected: "No connectat",
				connect: "Connectar",
				disconnect: "Desconnectar",
				company: "Empresa",
				connected_as: "Connectat com",
				api_token: "API token",
				api_token_placeholder: "Enganxa aquí el teu API token de Pipedrive",
				api_token_help: "A Pipedrive: Preferències personals → API → Personal API token.",
				slack_channels_title: "Canals de Slack",
				pipedrive_title: "Pipedrive",
				pipedrive_description: "Connecta Pipedrive per vincular oportunitats i reserves amb el teu CRM.",
				pipedrive_connected: "Pipedrive connectat",
				pipedrive_not_connected: "Pipedrive no connectat",
				pipedrive_connect_success: "Pipedrive connectat correctament",
				pipedrive_connect_error: "No s'ha pogut connectar Pipedrive. Revisa l'API token.",
				pipedrive_disconnect_success: "Pipedrive desconnectat",
				pipedrive_disconnect_error: "No s'ha pogut desconnectar Pipedrive"
			},
			organization: {
				slack_configuration: "Configuració de Slack",
				slack_install_description:
					"Instal·leu l'aplicació de Slack per rebre notificacions dels esdeveniments.",
				slack_connected: "Slack connectat",
				slack_not_connected: "Slack no connectat",
				event_notifications_channel: "Canal de notificacions d'esdeveniments",
				staff_notifications_channel: "Canal de notificacions del personal",
				select_channel: "Seleccionar canal",
				refresh_channels: "Actualitzar canals",
				save_slack_config: "Desar la configuració de Slack",
				slack_config_saved: "Configuració de Slack desada",
				error_saving_slack_config: "Error en desar la configuració de Slack",
				channels_refreshed: "Canals actualitzats",
				error_refreshing_channels: "Error en actualitzar els canals",
				initial_position: "Posició Inicial per a Esdeveniments",
				initial_position_label: "Ubicació inicial",
				search_location: "Cerca ubicació...",
				error_loading_places: "Error al carregar el servei de llocs",
				link_app: "Enllaç de l'aplicació",
				testing_link: "Enllaç de proves jocs Online",
				testing_link_description:
					"Comparteix aquest enllaç amb els clients perquè puguin comprovar la connexió i la configuració del dispositiu abans de l'esdeveniment.",
				booking_agent: "Agent IA",
				booking_agent_description: "Quan està actiu, el personal pot demanar a cada reserva una anàlisi amb l'Agent IA.",
				booking_agent_enabled: "Activar Agent IA a les reserves",
				booking_agent_extra_prompt: "Instruccions extra del prompt",
				booking_agent_extra_prompt_help: "S'afegeixen al prompt base del sistema. Fes-lo servir per al checklist o regles pròpies de l'organització.",
				booking_agent_extra_prompt_placeholder: "Ex.: Revisar sempre el contacte on-site, el menú confirmat i el parking.",
				open: "Obrir",
				organization_url: "URL de l'organització",
				copy: "Copiar",
				users: "Usuaris",
				create_new_user: "Crear Nou Usuari",
				edit_user: "Editar Usuari",
				name: "Nom",
				enter_name: "Introdueix el nom",
				role: "Rol",
				cancel: "Cancel·lar",
				save: "Desar",
				email: "Email",
				enter_email: "Insereix el correu electrònic",
				password: "Contrasenya",
				enter_password: "Introdueix la contrasenya",
				confirm_password: "Confirmar la contrasenya",
				confirm_password_placeholder: "Confirmeu la nova contrasenya",
				create: "Crear",
				confirm_deletion: "Confirmar eliminació",
				delete_user_confirmation: "Esteu segurs que voleu eliminar l'usuari {name}?",
				delete: "Eliminar",
				organization_qr_code: "Codi QR de l'organització",
				administrator: "Administrador",
				facilitator: "Facilitador",
				edit: "Editar",
				actions: "Accions",
				url_copied: "URL copiada al porta-retalls",
				user_updated: "Usuari actualitzat amb èxit",
				error_updating_user: "Error en actualitzar l'usuari",
				user_created: "Usuari creat amb èxit",
				error_creating_user: "Error en crear l'usuari",
				user_deleted: "Usuari eliminat amb èxit",
				error_deleting_user: "Error en eliminar l'usuari",
				select_role: "Seleccioneu un rol",
				available_languages: "Idiomes disponibles",
				select_languages: "Seleccioneu els idiomes",
				default_language: "Idioma per defecte",
				select_default_language: "Seleccioneu l'idioma per defecte",
				at_least_one_language_required: "Cal seleccionar almenys un idioma",
				make_all_pdfs: "Generar tots els PDFs",
				make_all_pdfs_cooldown:
					"La generació de PDF ja està en curs. Podeu començar de nou 45 minuts després de l'última execució.",
				make_all_pdfs_started: "La generació de PDF s'ha iniciat.",
				make_all_pdfs_error: "No s'ha pogut iniciar la generació de PDF. Si us plau, torneu-ho a provar.",
				personalization: "Personalització",
				monitor_info: "Informació de monitor",
				field_label: "Etiqueta del camp",
				field_type: "Tipus de camp",
				field_options: "Opcions del camp (separades per comes)",
				visible_to_staff: "Visible per al staff",
				required: "Obligatori",
				active: "Actiu",
				add_field: "Afegir camp",
				booking_defaults: "Camps per defecte de reserva",
				booking_default_field: "Camp de reserva",
				booking_default_value: "Valor per defecte",
				booking_default_files: "Fitxers plantilla",
				booking_default_save_first_upload: "Desa la configuració abans de pujar fitxers plantilla.",
				booking_default_json_hint: "Introduïu JSON vàlid (array o objecte).",
				fundae_enabled: "Activar camps FUNDAE",
				contracts_enabled: "Activar contractes a reserves",
				contracts: "Contractes",
				booking_custom_fields: "Camps personalitzats de reserva",
				booking_custom_fields_hint: "Aquests camps apareixen a la reserva i es poden usar com a variables del contracte.",
				contract_template: "Plantilla del contracte",
				contract_template_hint: "Escriu el contracte i inseriu variables de la reserva o camps del client on vulguis. Els camps del client no surten sols: cal inserir-los al text.",
				insert_booking_variable: "Variable o camp",
				insert_variable: "Inserir variable",
				add_client_field: "Crear camp del client",
				client_field_button_tooltip: "Crea un camp que el client omplirà i l'insereix al contracte a la posició del cursor.",
				client_field_tooltip: "Text d'ajuda (tooltip)",
				contract_client_fields: "Camps del client",
				contract_client_fields_hint: "Camps que omple el client. Crea'ls aquí i inseriu la seva variable al text del contracte on vulguis.",
				contract_template_expand: "Mostrar text del contracte",
				contract_template_collapse: "Minimitzar text del contracte",
				client_field_option_prefix: "Client",
				signing_fields_title: "Camps per firmar",
				signing_fields_hint: "Nom i firma sempre es demanen en firmar. Aquí només afegeixes camps extra de text (p. ex. DNI).",
				signing_field_required: "Obligatori",
				add_signing_text_field: "Afegir camp de text",
				signing_type_name: "Nom",
				signing_type_signature: "Firma dibuixada",
				signing_type_text: "Text",
				signature_template_title: "Paràgraf de firma",
				signature_template_hint: "Text que s'afegeix al contracte quan el client firma. Insereix variables de firma i dels camps de firma.",
				insert_signature_variable: "Variable de firma",
				insert_into_signature: "Inserir al paràgraf de firma",
				signature_var_signer_name: "Nom del firmant",
				signature_var_signed_datetime: "Data i hora",
				signature_var_signed_date: "Data",
				signature_var_signed_time: "Hora",
				signature_var_signature_image: "Imatge de la firma",
				signature_var_signed_by_label: "Etiqueta «Firmat per» (idioma reserva)",
				signature_var_date_label: "Etiqueta «Data i hora» (idioma reserva)",
				signature_var_company_signer_name: "Nom firmant empresa",
				signature_var_company_signature_image: "Firma de l'empresa",
				company_signature_title: "Firma de l'empresa",
				company_signature_hint: "Nom i firma de la teva empresa. S'afegeixen automàticament a tots els contractes firmat.",
				company_signer_name: "Nom del firmant (empresa)",
				company_signature_draw: "Dibuixar firma de l'empresa",
				company_signature_clear: "Treure firma de l'empresa",
				booking_field_type_text: "Text",
				booking_field_type_textarea: "Text llarg",
				booking_field_type_number: "Número",
				booking_field_type_date: "Data",
				booking_field_type_select: "Selector",
				booking_field_type_checkbox: "Casella",
				notifications: "Notificacions",
				notifications_channels: "Canals",
				notifications_channel_email: "Correu",
				notifications_channel_whatsapp: "WhatsApp",
				notifications_list: "Notificacions",
				notifications_enabled: "Activa",
				notifications_channels_for_event: "Enviar per",
				notifications_trigger_monitor_activity_offer: "Quan un monitor rep una oferta d'activitat",
				notifications_trigger_monitor_accept_reject: "Quan un monitor accepta o rebutja una activitat",
				notifications_whatsapp_inbound: "Resposta automàtica de WhatsApp",
				notifications_whatsapp_inbound_hint:
					"Text que s'envia quan un monitor escriu al número de WhatsApp.",
				notifications_event_list: "Notificacions d'esdeveniment",
				notifications_event_hint:
					"Avisos programats respecte a l'inici de l'esdeveniment, de 3 dies abans a 3 dies després.",
				notifications_event_add: "Afegir notificació",
				notifications_event_edit: "Editar notificació",
				notifications_event_name: "Nom",
				notifications_event_name_required: "Cada notificació d'esdeveniment necessita un nom.",
				notifications_event_when: "Quan",
				notifications_event_when_before: "Abans de l'esdeveniment",
				notifications_event_when_after: "Després de l'esdeveniment",
				notifications_event_days: "Dies",
				notifications_event_hours: "Hores",
				notifications_event_minutes: "Minuts",
				notifications_event_message: "Text",
				notifications_event_recipients: "Destinataris",
				notifications_event_recipient_sales_responsible: "Responsable de venda",
				notifications_event_recipient_production_responsible: "Responsable de producció",
				notifications_event_recipient_responsible_monitor: "Responsable de monitors",
				notifications_event_recipient_monitors: "Monitors",
				field_type_text: "Text",
				field_type_select: "Selecció",
				field_type_multiselect: "Selecció múltiple",
				field_type_checkbox: "Casella",
				field_type_phone_communications: "Telèfon comunicacions"
			},
			credit_consumption: {
				title: "Consum de crèdits",
				subtitle: "Ús de crèdits de l'organització, totals de facturació i estat del pagament.",
				entries: "Registres",
				total_credits: "Crèdits totals",
				paid_amount: "Import pagat",
				pending_amount: "Import pendent",
				filters: "Filtres",
				date_from: "Data des de",
				date_to: "Data fins a",
				activity_type: "Tipus d'activitat",
				payment_status: "Estat del pagament",
				apply: "Aplicar",
				consumption_details: "Detall del consum",
				rows_count: "{count} files",
				col_date: "Data",
				col_event: "Esdeveniment",
				col_activity: "Activitat",
				col_credits: "Crèdits",
				col_unit_price: "Preu unitari",
				col_amount: "Import",
				col_paid: "Pagat",
				status_paid: "Pagat",
				status_pending: "Pendent",
				empty_state: "No hi ha consum de crèdits amb els filtres actuals.",
				filter_all: "Tots",
				filter_paid: "Pagat",
				filter_pending: "Pendent",
				all_activities: "Totes les activitats",
				activity_fallback: "Activitat {id}",
				load_failed: "No s'ha pogut carregar el consum de crèdits."
			}
		}
	},
	events: {
		active_events: "Esdeveniments actius",
		event: "Activitat",
		game: "App",
		day: "Data",
		actions: "Accions",
		view_event: "Veure activitat",
		enter: "Entrar",
		finish: "Finalitzar",
		reopen: "Reobrir",
		delete_event: "Eliminar esdeveniment",
		are_you_sure: "Estàs segur?",
		accept: "Acceptar",
		cancel: "Cancel·lar",
		no_content: "No hi ha contingut",
		no_content_in_activity: "No hi ha contingut en aquesta activitat",
		edit: "Editar",
		download: "Descarregar",
		delete: "Eliminar",
		search_name: "Buscar per nom..."
	},
	client: {
		budgets: "Pressupostos",
		bookings: "Reservas",
		billed: "Facturat"
	},
	qr_scanner: {
		camera_permission_denied: "ERROR: Permís de càmera denegat",
		no_camera_found: "ERROR: No s'ha trobat càmera al dispositiu",
		unable_to_start_camera: "ERROR: No es pot iniciar la càmera"
	},
	map: {
		search_address: "Cercar una adreça...",
		locate_button: "Centrar mapa",
		switch_map_type: "Canviar tipus de mapa"
	},
	musicalBingo: {
		staff: {
			skip_challenge: "Saltar repte",
			song_challenge: "Cançó del repte",
			song_post_challenge: "Cançó del post repte",
			winner_team: "Equip guanyador",
			challenge_explaining: "Explicant el repte",
			volume_up: "Volum +",
			volume_down: "Volum -",
			command_send: "Comandament enviat",
			next_step_send: "Següent pas enviat",
			controls: "Controls",
			status: "Estat",
			start_game: "Iniciar joc",
			waiting_game: "Esperant joc",
			waiting_set: "Seleccionant Bingo",
			next_step: "Següent pas",
			start_bingo: "Iniciar Bingo",
			game_start_soon: "Bingo llest per començar",
			start_bingo_public: "Iniciar Bingo",
			playing_song: "Reproduint la cançó",
			result_song: "Resultat cançó",
			pause_song: "Pausar cançó",
			resume_song: "Reanudar cançó",
			repeat_song: "Repetir cançó",
			song_result: "Resultat cançó",
			playing_challenge: "Reproduint repte",
			remaining_time: "Temps restant",
			team_answers: "Respostes dels equips",
			correct_answers: "Respostes correctes",
			players: "jugadors",
			song: "Cançó",
			next_image: "Següent imatge",
			bingo_select: "Seleccionar Bingo",
			final_ranking: "Finalitzar ranking",
			final_photo: "Finalitzar foto",
			bingo_done: "Bingo finalitzat",
			finish_game: "Finalitzar bingo",
			bingo_finished: "Bingo finalitzat",
			stop_bingo: "Aturar bingo",
			live_view: "Vista en directe",
			exclude_teams: "Equips que no han de guanyar aquest bingo",
			exclude_teams_placeholder: "Seleccionar equips (opcional)",
			exclude_teams_all_error: "Almenys un equip ha de poder guanyar"
		},
		public_view: {
			re_take_photo: "Tornar a fer fotografia",
			select_option: "Selecciona l'opció més votada",
			quiz_results: "Resultats del quiz",
			challenge_results: "Resultats reptes",
			quiz: "Quiz",
			fill: "Omple la frase",
			two_vs_two: "Repte per equips",
			one_vs_all: "Enquesta d'equip",
			photo: "Fotografia",
			waiting_game: "Esperant joc",
			selecting_bingo: "Seleccionant Bingo",
			bingo_start_soon: "El Bingo començarà en breu",
			playing: "Endevina la cançó",
			ranking: "Ranking",
			seconds: "segons",
			points: "punts",
			answer_sent: "Resposta enviada",
			answer_not_sent: "No s'ha pogut enviar la resposta",
			send_answer: "Enviar resposta",
			remaining_time: "Temps restant",
			team_answers: "Respostes dels equips",
			correct_answers: "Respostes correctes",
			players: "jugadors",
			photo_show: "Fotos dels equips",
			go_to_stage: "Un representant del teu equip ha de pujar a l'escenari",
			go_to_stage_all: "Que puji tot l'equip a l'escenari",
			this_groups_to_stage: "Esperant que els equips vagin a l'escenari",
			challenge_start_soon: "Espera que els representants escollits pugin a l'escenari",
			turn_of_team: "Torn de l'equip",
			vote_of_team: "Hora de votar",
			placement: "Equip posicionant-se",
			draw: "Empat",
			fill_write_answer: "R omplir resposta",
			fill_answer: "R omplir la resposta",
			quiz_write_answer: "Contestant el quiz",
			photo_write_answer: "Enviant les fotos",
			upload_photo: "Fer fotografia",
			photo_saved: "Foto guardada",
			fill_answer_placeholder: "Escriu la resposta"
		},
		player: {
			bingo_start_soon: "El Bingo començarà de seguida.",
			selecting_bingo: "Seleccionant Bingo",
			no_picture: "No hi ha foto d'equip",
			upload_team_picture: "Pujar foto d'equip",
			not_started: "L'activitat encara no ha començat",
			photo_show: "Fotos dels equips",
			song_marked: "Cançó marcada",
			answered: "Respost",
			correct_song: "Cançó correcta",
			wrong_song: "Cançó incorrecta",
			error_marking_song: "Error al marcar la cançó",
			bingo_finished: "Bingo finalitzat",
			winner_team: "Equip guanyador",
			photo_screen: "Fotos dels equips",
			play: "Reproduir",
			pause: "Pausar",
			restart: "Reiniciar",
			start_game: "INICIAR JOC",
			audio_permission_message: "Fes clic al botó a continuació per activar la reproducció d'àudio del joc.",
			tab_muted_warning: "⚠️ La Pestanya del Navegador Està Silenciada",
			tab_muted_instructions:
				"Si us plau, desactiva el silenci de la pestanya del navegador fent clic a l'icona de l'altaveu a la pestanya per habilitar la reproducció d'àudio.",
			no_team_responding: "No ha respost cap equip correctament",
			final_ranking: "Ranking Final"
		},
		ranking_musical_bingo: {
			press_button_view_ranking: "Prem el botó per veure el rànquing",
			view_ranking: "Veure rànquing"
		}
	},
	summaries: {
		description: "Descarrega i gestiona resums i informes de monitors",
		monitor_summaries: "Resums de Monitors",
		download_monitor_summary: "Descarregar Resum de Monitors",
		select_month: "Seleccionar Mes",
		select_month_description: "Tria el mes pel qual vols descarregar l'informe de resum de monitors.",
		download: "Descarregar",
		download_success: "Descàrrega Exitosa",
		download_success_detail: "El resum de monitors per a {month} s'ha descarregat correctament.",
		download_error: "Error de Descàrrega",
		download_error_detail:
			"Ha ocorregut un error en descarregar el resum de monitors. Si us plau, torna-ho a intentar."
	},
	pause_game: "Pausar joc",
	resume_game: "Reprendre joc",
	catalan: "Català",
	staff_page: {
		title: "Registres del personal",
		description: "Veure i gestionar els registres del monitor per rang de dates.",
		date_range: "Rang de dates",
		select_year: "Any",
		select_month: "Mes",
		all_months: "Tots els mesos",
		filter_by_staff: "Filtrar per personal",
		filter_by_accepted: "Estat acceptat",
		all_staff: "Tot el personal",
		filter_by_paid: "Estat de pagament",
		all: "Tot",
		paid: "Pagat",
		not_paid: "No pagat",
		booking: "Reserva",
		booking_name: "Nom de la reserva",
		date: "Data",
		staff: "Personal",
		salary: "Sou",
		accepted: "Acceptat",
		responsible: "Responsable",
		paid_status: "Estat pagat",
		comments: "Comentaris",
		mark_selected_paid: "Marcar seleccionats com a pagats",
		mark_selected_not_paid: "Marcar seleccionats com a no pagats",
		mark_all_paid: "Marcar tots com a pagats",
		mark_all_not_paid: "Marcar tots com a no pagats",
		update_success: "Registres actualitzats correctament",
		update_error: "Error en actualitzar registres. Si us plau, torna a intentar-ho.",
		select_records: "Selecciona un o més registres",
		loading: "Carregant...",
		no_records: "No s'han trobat registres per al període seleccionat.",
		records_updated: "{count} registre(s) actualitzat(s)",
		total_salary: "Sou total",
		total_salary_to_be_paid: "Total sou a pagar"
	},
	gm_activities_page: {
		description: "Consulta les teves activitats, pagaments i reserves pendents.",
		activities: "Activitats",
		pending_reservation: "Reserva pendent"
	}
}
